/* gift-quiz.js — the Gift Finder (sections/gift-quiz.liquid).
   Externalised 2026-09-08 from the section's inline <script> so the same code
   can be cached across the 38 collection pages that carry the band. One
   initRoot() per [data-section-type="gift-quiz"]; re-inits on
   shopify:section:load. Loaded with `defer` from the section; the load guard
   below keeps a second instance's <script> tag from running the file twice. */
(function () {
  if (window.__giftQuizLoaded) return;
  window.__giftQuizLoaded = true;
  /* The card lives ONLY in cart.note (2026-09-14): "To <name>," on the first line, then the
     words. Order attributes land in ShipStation's Note From Buyer as a <br/>-joined duplicate.
     Same rule as cart-drawer.js / sections/cart-drawer.liquid / the dashboard order sync. */
  var RETIRED_GIFT_ATTRIBUTES = {
    'Gift Note — To': null, 'Gift Note — From': null, 'Gift Note': null,
    'Gift Occasion': null, 'Your Monsuri box': null
  };
  function splitGiftNote(note) {
    var s = String(note || '');
    var nl = s.indexOf('\n');
    var head = nl === -1 ? s : s.slice(0, nl);
    var m = /^To (.+),$/.exec(head.trim());
    var name = m ? m[1].trim() : '';
    if (!name || name.length > 40) return { to: '', message: s };
    return { to: name, message: nl === -1 ? '' : s.slice(nl + 1) };
  }
  function joinGiftNote(to, message) {
    var name = String(to || '').trim();
    var words = splitGiftNote(message).message; /* never stack two "To" lines */
    return name ? 'To ' + name + ',' + (words ? '\n' + words : '') : words;
  }
    function initRoot(root) {
    if (!root || root.dataset.quizInit === 'true') return;
    var sectionId = root.getAttribute('data-section-id') || '';
    /* Lifecycle (Codex Sol HIGH, 2026-09-08): every global listener/observer this
       instance creates registers a cleanup; a Theme-Editor reload (or unload)
       tears the previous instance down BEFORE the next one claims the root. */
    window.__gq = window.__gq || {};
    if (window.__gq[sectionId] && typeof window.__gq[sectionId].teardown === 'function') { try { window.__gq[sectionId].teardown(); } catch (_) {} }
    root.dataset.quizInit = 'true';
    var cleanup = [];
    function on(target, evt, fn, opts) { target.addEventListener(evt, fn, opts); cleanup.push(function () { target.removeEventListener(evt, fn, opts); }); }
    function watch(observer) { cleanup.push(function () { try { observer.disconnect(); } catch (_) {} }); return observer; }
    window.__gq[sectionId] = { teardown: function () { cleanup.forEach(function (f) { try { f(); } catch (_) {} }); cleanup = []; root.dataset.quizInit = ''; } };

    /* Scope to `script[...]` — `data-quiz-questions` is ALSO on the
       container div wrapping the question fieldsets, so an unqualified
       selector returns the div (whose textContent is not JSON) and
       safeJson returns null. */
    var products = safeJson(root.querySelector('script[data-quiz-products]'));
    var questions = safeJson(root.querySelector('script[data-quiz-questions]'));
    var config = safeJson(root.querySelector('script[data-quiz-config]')) || {};
    var fallback = safeJson(root.querySelector('script[data-quiz-fallback]'));

    if (!Array.isArray(products)) products = [];
    if (!Array.isArray(questions)) questions = [];

    /* ——— Band presentation + collection context (2026-09-08) ——— */
    var isBand = config.presentation === 'band';
    var surface = config.surface || 'page';
    var bandEl = root.querySelector('[data-quiz-band]');
    var bodyEl = root.querySelector('[data-quiz-body]');
    var expandBtn = root.querySelector('[data-quiz-expand]');
    var collapseBtn = root.querySelector('[data-quiz-collapse]');
    var recipientWrap = root.querySelector('[data-quiz-recipient-wrap]');
    var recipientInput = root.querySelector('[data-quiz-recipient]');
    var giftMessageInput = root.querySelector('[data-quiz-gift-message]');
    var noteSyncTimer = null;
    /* typing in either field reaches the cart within a second, and the drawer re-renders — one
       note everywhere (quiz, drawer, gift-set builder) */
    var noteStatusEl = root.querySelector('[data-quiz-note-status]');
    function noteStatus(text) { if (!noteStatusEl) return; noteStatusEl.hidden = !text; noteStatusEl.textContent = text || ''; }
    /* ONE owner when the drawer is open (2026-09-09, founder): the drawer's card field is the live
       truth of the note, so the quiz hands its text to that field and fires its input event — the
       drawer's own model saves it, shows "Saved", and mirrors it back into every name="note" field.
       Without a drawer field on the page (empty bag), the quiz writes the cart itself. */
    function pushNoteToDrawer() {
      var dNote = document.querySelector('[data-cdw-gift-note]'), dTo = document.querySelector('[data-cdw-gift-to]');
      if (!dNote) return false;
      var fire = function (el, val) { if (el.value === val) return; el.value = val; el.dispatchEvent(new Event('input', { bubbles: true })); };
      /* words merely hydrated from the bag are not pushed — the drawer already holds the bag's
         current words, and a stale copy would save over a newer one */
      if (state.giftMessageTouched) fire(dNote, (state.giftMessage || '').slice(0, 300));
      if (dTo) fire(dTo, (state.recipient || '').slice(0, 40));
      return true;
    }
    function scheduleNoteSync() {
      if (noteSyncTimer) window.clearTimeout(noteSyncTimer);
      noteStatus('Saving\u2026');
      noteSyncTimer = window.setTimeout(function () {
        noteSyncTimer = null;
        var viaDrawer = pushNoteToDrawer();
        syncRecipientAttribute().then(function () {
          noteStatus('Saved to your bag');
          if (!viaDrawer && state.noteSyncedOnce) document.dispatchEvent(new CustomEvent('cart:refresh'));
          state.noteSyncedOnce = true;
        });
      }, 900);
    }
    if (giftMessageInput) giftMessageInput.addEventListener('input', function () { state.giftMessage = giftMessageInput.value.slice(0, 300); state.giftMessageTouched = true; scheduleNoteSync(); });
    /* the result opens with whatever the bag already carries: the card (the drawer's note, the
       builder's note) AND the lines — so "Add both" never duplicates a match already in the bag */
    function readCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    function noteCartLines(cart) {
      state.inCart = {};
      (cart && cart.items || []).forEach(function (it) { if (it && it.variant_id) state.inCart[it.variant_id] = (state.inCart[it.variant_id] || 0) + (it.quantity || 1); });
      if (state.lastResult && state.addOnProduct) {
        var pr = products.find(function (p) { return p.id === state.lastResult.primaryId; }) || (fallback && fallback.id === state.lastResult.primaryId ? fallback : null);
        if (pr && pr.variant_id && state.inCart[pr.variant_id]) noteAdded(pr);
      }
    }
    function hydrateGiftNoteFromCart() {
      readCart().then(function (cart) {
        if (!cart) return;
        noteCartLines(cart);
        if (!recipientWrap || recipientWrap.hidden) return;
        var card = splitGiftNote(cart.note);
        if (card.to && !state.recipient && recipientInput) { state.recipient = card.to.slice(0, 40); recipientInput.value = state.recipient; updateNamedEyebrow(); }
        if (card.message && !state.giftMessage && giftMessageInput) { state.giftMessage = card.message.slice(0, 300); giftMessageInput.value = state.giftMessage; }
        /* what the bag already holds counts as synced — no write until something changes */
        if (cart.note) state.recipientSynced = (state.recipient || '') + '|' + (state.giftMessage || '');
      }).catch(function () { /* the fields stay empty */ });
    }
    var keepBrowsing = root.querySelector('[data-quiz-keep-browsing]');
    var stripEl = root.querySelector('[data-quiz-strip]');
    var resultEyebrowEl = root.querySelector('[data-quiz-result-eyebrow]');
    var resultEyebrowDefault = resultEyebrowEl ? resultEyebrowEl.textContent : '';
    /* context answers arrive as an object (the collection's json metafield) or
       as the template's "key:tag,key:tag" fallback string */
    var contextAnswers = {};
    (function () {
      var raw = config.context_answers;
      if (raw && typeof raw === 'object') { contextAnswers = raw; return; }
      if (typeof raw === 'string' && raw.trim()) {
        raw.split(',').forEach(function (pair) {
          var kv = pair.split(':');
          if (kv.length === 2 && kv[0].trim() && kv[1].trim()) contextAnswers[kv[0].trim()] = kv[1].trim();
        });
      }
    })();

    /* Seasonal options (2026-09-09): an option may carry season "MMDD-MMDD"; outside
       that window it is DORMANT — not rendered, not lockable, but still usable by the
       free-text keyword map so "mother's day" typed in May scores in May. */
    function inSeason(opt) {
      if (!opt || !opt.season) return true;
      var m = String(opt.season).match(/^(\d{2})(\d{2})-(\d{2})(\d{2})$/);
      if (!m) return true;
      var d = new Date(), today = (d.getMonth() + 1) * 100 + d.getDate();
      var from = parseInt(m[1] + m[2], 10), to = parseInt(m[3] + m[4], 10);
      return from <= to ? (today >= from && today <= to) : (today >= from || today <= to);
    }
    function isGiftTag(tag) { return typeof tag === 'string' && tag !== 'self' && tag.indexOf('gift') === 0; }
    questions.forEach(function (q) {
      if (typeof q.options_json === 'string' && q.options_json.length) {
        try { q.options = JSON.parse(q.options_json); } catch (_) { q.options = []; }
      } else { q.options = []; }
      q.options.forEach(function (o) { if (o) o.dormant = !inSeason(o); });
    });

    var state = {
      answers: new Array(questions.length).fill(null),
      currentIndex: 0,
      startedAt: Date.now(),
      perQuestionAt: [Date.now()],
      sessionId: 'gfq-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10),
      recipient: '',
      recipientSynced: '',
      lastResult: null
    };

    /* Context locks (2026-09-08): a question the collection already answers is
       answered up front (locked) and skipped in navigation; it still scores,
       and the buyer can change it from the result ("actually, for me"). */
    function applyContextLocks() {
      var locked = [], unmatched = [];
      questions.forEach(function (q, i) {
        var tag = contextAnswers[q.key];
        if (!tag) return;
        /* buyer_type:gift no longer locks Q1 away (2026-09-09): the question stays so the
           recipient can be named; only the "Me" option is withheld on gift collections. */
        if (q.key === 'buyer_type' && tag === 'gift') { state.giftOnly = true; root.dataset.quizContextGiftOnly = 'true'; return; }
        var opt = (q.options || []).find(function (o) { return o && o.tag === tag; });
        if (opt && opt.dormant) return; /* out of season: dormant, not an error */
        if (!opt) { unmatched.push(q.key); return; }
        state.answers[i] = { key: q.key, tag: tag, opt: opt, locked: true };
        locked.push(q.key);
      });
      root.dataset.quizContextLocked = locked.join(',');
      root.dataset.quizContextUnmatched = unmatched.join(',');
      return locked;
    }
    function firstVisibleIndex() {
      for (var i = 0; i < questions.length; i++) { if (questionVisible(i)) return i; }
      return 0;
    }
    function isGiftBuyer() {
      return state.answers.some(function (a) { return a && a.key === 'buyer_type' && isGiftTag(a.tag); });
    }
    /* the recipient word from Q1 ("Mom", "your partner", "a friend") for neutral copy */
    function recipientWord() {
      var a = state.answers.find(function (x) { return x && x.key === 'buyer_type'; });
      return (a && a.opt && a.opt.recipient) ? String(a.opt.recipient) : '';
    }

    /* Zero-party telemetry (2026-08-24, founder-approved): every COMPLETION
       posts the anonymous answer path to the dashboard (no email, no PII;
       "other" texts capped at 120 chars). Fire-and-forget + keepalive —
       a failed POST never touches the quiz UX. */
    function sendTelemetry(payload) {
      try {
        payload.quiz_id = config.quiz_id;
        payload.session_id = state.sessionId;
        payload.surface = surface;
        payload.collection_handle = config.collection_handle || null;
        payload.page_path = config.page_path || null;
        payload.presentation = config.presentation || 'full';
        payload.recipient_named = !!state.recipient;
        fetch((config.telemetry_url || 'https://dashboard.monsuri.com') + '/api/quiz/telemetry', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function () { /* never surfaces */ });
      } catch (_) { /* never surfaces */ }
    }

    /* "Order today, arrives by <weekday, Mon D>": the ship day is today if
       it is a business day before the warehouse cutoff (Utah time), else the
       next business day; arrival = ship day + ship_days_max business days.
       Honest by construction — it always quotes the slow end of the window. */
    function arrivalLabel() {
      try {
        var maxDays = Math.max(1, parseInt(config.ship_days_max, 10) || 5);
        var cutoff = parseInt(config.ship_cutoff_hour, 10);
        if (isNaN(cutoff)) cutoff = 14;
        var now = new Date();
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', hour: 'numeric', hour12: false, weekday: 'short' }).formatToParts(now);
        var hour = 0, wd = '';
        parts.forEach(function (p) { if (p.type === 'hour') hour = parseInt(p.value, 10) % 24; if (p.type === 'weekday') wd = p.value; });
        var isBiz = wd !== 'Sat' && wd !== 'Sun';
        var d = new Date(now.getTime());
        var shipsToday = isBiz && hour < cutoff;
        if (!shipsToday) {
          do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
        }
        var added = 0;
        while (added < maxDays) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) added++;
        }
        return 'Order today, arrives by ' + d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      } catch (_) { return ''; }
    }

    var introEl = root.querySelector('[data-quiz-intro]');
    var welcomeEl = root.querySelector('[data-quiz-welcome]');
    var welcomeProduct = root.querySelector('[data-quiz-welcome-product]');
    var welcomeView = root.querySelector('[data-quiz-welcome-view]');
    var welcomeRetake = root.querySelector('[data-quiz-welcome-retake]');
    /* the strip's two leads (2026-09-09): the default prompt and the returning-visitor match */
    var bandLead = root.querySelector('[data-quiz-band-lead]');
    var bandWelcome = root.querySelector('[data-quiz-band-welcome]');
    var bwProduct = root.querySelector('[data-quiz-band-welcome-product]');
    var bwView = root.querySelector('[data-quiz-band-welcome-view]');
    var bwRetake = root.querySelector('[data-quiz-band-welcome-retake]');
    var bwWired = false;
    var questionNodes = root.querySelectorAll('[data-quiz-question]');
    var progressNodes = root.querySelectorAll('[data-progress-index]');
    var resultEl = root.querySelector('[data-quiz-result]');
    var primaryEl = root.querySelector('[data-quiz-primary]');
    var alternatesEl = root.querySelector('[data-quiz-alternates]');
    var metaEl = root.querySelector('[data-quiz-meta]');
    var restartBtn = root.querySelector('[data-quiz-restart]');
    var emailForm = root.querySelector('[data-quiz-email-form]');
    var gateEl = root.querySelector('[data-quiz-gate]');
    var bundleEl = root.querySelector('[data-quiz-bundle]');
    var bundleGrid = root.querySelector('[data-quiz-bundle-grid]');
    var bundleStatus = root.querySelector('[data-quiz-bundle-status]');
    var answersEl = root.querySelector('[data-quiz-answers]');
    var answersList = root.querySelector('[data-quiz-answers-list]');

    var saved = loadSaved();
    if (saved && saved.handle) {
      var matchedProduct = products.find(function (p) { return p.handle === saved.handle; })
        || (fallback && fallback.handle === saved.handle ? fallback : null);
      /* The saved match may not exist in THIS collection's pool (2026-09-08):
         re-score the saved answers against what is on this page instead. */
      if (!matchedProduct && Array.isArray(saved.answers) && saved.answers.length && products.length) {
        try {
          var rescored = scoreCandidates(products, saved.answers);
          if (rescored[0] && rescored[0].score > 0) matchedProduct = rescored[0].product;
        } catch (_) { /* fall through: no welcome pill */ }
      }
      if (matchedProduct) {
        if (saved.recipient) state.recipient = String(saved.recipient).slice(0, 40);
        welcomeProduct.textContent = matchedProduct.title;
        welcomeEl.hidden = false;
        welcomeView.addEventListener('click', function () {
          showResultFromSavedWired(saved, matchedProduct);
        });
        welcomeRetake.addEventListener('click', function () {
          clearSaved();
          clearRecipient();
          welcomeEl.hidden = true;
          track('gift_quiz_restarted', {});
        });
        showBandReturning(matchedProduct, saved);
        /* marks on the grid from the saved match, before any tap */
        state.lastResult = { primaryId: matchedProduct.id, altIds: [] };
        markGrid();
        observeGrid();
      }
    }

    /* ——— Capture gate wiring (2026-08-24) — a REAL consented subscribe via
       Klaviyo's client API, never the identify-only path. Wired ONCE at init. ——— */
    state.gatePassed = false;
    state.pendingResult = null;
    function subscribeProfile(email, done) {
      var props = { signup_source: 'quiz', last_quiz_id: config.quiz_id, last_quiz_at: new Date().toISOString() };
      state.answers.forEach(function (a) {
        if (!a) return;
        if (a.key === 'buyer_type') props.buyer_type = a.tag;
        if (a.key === 'occasion') props.gift_occasion = a.tag;
        if (a.key === 'concern') props.concern_pref = a.tag;
        if (a.key === 'ritual') props.ritual_pref = a.tag;
        if (a.key === 'scent' || a.key === 'scent_tags') props.scent_pref = a.tag;
        if (a.key === 'price' || a.key === 'price_tier') props.price_pref = a.tag;
      });
      if (state.pendingResult && state.pendingResult.primary && state.pendingResult.primary.product) {
        props.last_match_handle = state.pendingResult.primary.product.handle;
        props.last_match_title = state.pendingResult.primary.product.title;
      }
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: config.quiz_name || 'Gift Finder Quiz',
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: config.email_list_id } } }
        }
      };
      /* Bounded (2026-09-05): a stalled Klaviyo call used to hold the buyer
         on "Saving…" forever with the skip disabled. Six seconds, then the
         match shows anyway; the subscribe may still land in the background. */
      var controller = (typeof AbortController === 'function') ? new AbortController() : null;
      var settled = false;
      function finish(ok) { if (settled) return; settled = true; done(ok); }
      var timer = setTimeout(function () { finish(false); if (controller) { try { controller.abort(); } catch (_) {} } }, 6000);
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.klaviyo_public_key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-10-15' },
        body: JSON.stringify(body),
        signal: controller ? controller.signal : undefined
      }).then(function (res) {
        clearTimeout(timer);
        finish(res.status >= 200 && res.status < 300);
      }).catch(function () { clearTimeout(timer); finish(false); });
    }

    var gateRevealed = false;
    if (gateEl) {
      var gateForm = gateEl.querySelector('[data-quiz-gate-form]');
      var gateInput = gateEl.querySelector('[data-quiz-gate-input]');
      var gateConsent = gateEl.querySelector('[data-quiz-gate-consent]');
      var gateStatus = gateEl.querySelector('[data-quiz-gate-status]');
      var gateSkip = gateEl.querySelector('[data-quiz-gate-skip]');
      var gateBusy = false;
      function revealFromGate() {
        /* Idempotent (Codex Sol MEDIUM, 2026-08-24): a submit followed by
           Skip would otherwise complete + instrument the quiz twice. */
        if (gateRevealed) return;
        gateRevealed = true;
        state.gatePassed = true;
        gateEl.hidden = true;
        completeQuiz();
      }
      if (gateForm) {
        gateForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (gateBusy) return;
          var email = (gateInput && gateInput.value || '').trim();
          if (!email || email.indexOf('@') === -1) {
            if (gateStatus) { gateStatus.hidden = false; gateStatus.textContent = 'That email doesn’t look right — one more try?'; }
            return;
          }
          if (gateConsent && !gateConsent.checked) {
            if (gateStatus) { gateStatus.hidden = false; gateStatus.textContent = 'Tick the box so we’re allowed to write to you — or use skip below.'; }
            return;
          }
          gateBusy = true;
          if (gateStatus) { gateStatus.hidden = false; gateStatus.textContent = 'Saving\u2026'; }
          subscribeProfile(email, function (ok) {
            gateBusy = false;
            if (gateRevealed) return; /* the buyer skipped while we were saving \u2014 nothing more to show */
            track('gift_quiz_email_captured', {
              quiz_id: config.quiz_id,
              list_id: config.email_list_id || null,
              gate: true,
              subscribed: ok,
              email_hash: hashEmail(email)
            });
            try {
              window._learnq = window._learnq || [];
              window._learnq.push(['identify', { $email: email }]);
            } catch (_) { /* best-effort */ }
            if (ok) {
              if (gateStatus) gateStatus.textContent = 'Saved \u2014 your welcome note is on its way.';
              setTimeout(revealFromGate, 450);
            } else {
              if (gateStatus) gateStatus.textContent = 'That didn\u2019t go through \u2014 here\u2019s your match anyway.';
              setTimeout(revealFromGate, 900);
            }
          });
        });
      }
      if (gateSkip) {
        /* The skip is NEVER disabled \u2014 a buyer who changes their mind mid-save
           still gets the match they earned (revealFromGate is idempotent). */
        gateSkip.addEventListener('click', function () {
          track('gift_quiz_gate_skipped', { quiz_id: config.quiz_id });
          revealFromGate();
        });
      }
    }

    var hasStartedEvent = false;
    function fireStartedOnce() {
      if (hasStartedEvent) return;
      hasStartedEvent = true;
      track('gift_quiz_started', { section_id: sectionId, question_count: questions.length });
    }

    /* Build option rows for every question from the already-parsed
       options_json. Server-side Liquid rendering was removed (see Liquid
       comment near the options container) because parse_json is not
       available on every Shopify storefront Liquid engine version. */
    questionNodes.forEach(function (qEl, qIndex) {
      var optionsContainer = qEl.querySelector('[data-quiz-options]');
      var opts = (questions[qIndex] && questions[qIndex].options) || [];
      if (optionsContainer && opts.length) {
        clearEl(optionsContainer);
        opts.forEach(function (opt, optIdx) {
          if (opt && opt.dormant) return;
          if (opt && opt.tag === 'self' && (state.giftOnly || contextAnswers.buyer_type === 'gift')) return;
          var label = document.createElement('label');
          label.className = 'gift-quiz__option';
          label.setAttribute('data-quiz-option', '');
          // Stagger index drives the cascade reveal in the CSS animation.
          label.style.setProperty('--idx', String(optIdx));

          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'q-' + qIndex + '-' + sectionId;
          input.value = (opt && opt.tag) || 'any';
          input.className = 'gift-quiz__option-input';
          input.setAttribute('data-quiz-option-input', '');

          var text = document.createElement('span');
          text.className = 'gift-quiz__option-label';
          text.textContent = (opt && opt.label) || (opt && opt.tag) || '\u2014';

          label.appendChild(input);
          label.appendChild(text);
          if (opt && opt.sub) {
            label.appendChild(document.createTextNode(' ')); /* "Me an hour…", not "Mean hour…" for AT */
            var sub = document.createElement('span');
            sub.className = 'gift-quiz__option-sub';
            sub.textContent = String(opt.sub);
            label.appendChild(sub);
          }
          if (opt && opt.popular) {
            var flag = document.createElement('span');
            flag.className = 'gift-quiz__option-flag';
            flag.textContent = 'most chosen';
            label.appendChild(flag);
          }
          optionsContainer.appendChild(label);

          /* "Something else" (opt.other): an OPTIONAL one-line field revealed
             on selection. Typing is never required — Continue works either
             way — so momentum survives while the words we could never have
             guessed get a place to land. 16px font (the iOS zoom law). */
          if (opt && opt.other) {
            var otherWrap = document.createElement('div');
            otherWrap.className = 'gift-quiz__other';
            otherWrap.hidden = true;
            otherWrap.setAttribute('data-quiz-other-wrap', '');
            var otherInput = document.createElement('input');
            otherInput.type = 'text';
            otherInput.maxLength = 120;
            otherInput.placeholder = 'Tell us in a few words — optional';
            otherInput.className = 'gift-quiz__other-input';
            otherInput.setAttribute('data-quiz-other-input', '');
            otherInput.setAttribute('aria-label', 'Tell us in your own words (optional)');
            otherWrap.appendChild(otherInput);
            /* after the radiogroup, never inside it — a text input is not a
               permitted child of role="radiogroup" */
            optionsContainer.parentNode.insertBefore(otherWrap, optionsContainer.nextSibling);
          }
        });
      }

      /* Reveal/hide the other-field with selection; store its text. */
      qEl.addEventListener('change', function () {
        var checked = qEl.querySelector('[data-quiz-option-input]:checked');
        var wrap = qEl.querySelector('[data-quiz-other-wrap]');
        if (!wrap) return;
        var isOther = !!(checked && checked.value === 'other');
        wrap.hidden = !isOther;
        if (isOther) {
          var inp = wrap.querySelector('[data-quiz-other-input]');
          if (inp) window.setTimeout(function () { inp.focus({ preventScroll: false }); }, 80);
        }
      });

      var nextBtn = qEl.querySelector('[data-quiz-next]');
      var prevBtn = qEl.querySelector('[data-quiz-prev]');
      var optionInputs = qEl.querySelectorAll('[data-quiz-option-input]');

      var advanceTimer = null;
      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          fireStartedOnce();
          qEl.querySelectorAll('[data-quiz-option]').forEach(function (opt) { opt.classList.remove('is-selected'); });
          var label = input.closest('[data-quiz-option]');
          if (label) label.classList.add('is-selected');
          if (nextBtn) nextBtn.disabled = false;
        });
        /* Auto-advance on a POINTER selection (2026-09-05 CRO wave): a tap on
           an answer is the answer — Continue doubled every question's taps.
           The tap lands on the LABEL (the radio is visually hidden, and its
           label-forwarded click carries no pointer info), so the pointer
           test lives there. Keyboard users are exempt (arrow keys fire
           change on every step; a keyboard activation has no pointerType
           and detail 0), and "Something else" keeps the Continue so the
           optional field can be typed into. */
        var optLabel = input.closest('[data-quiz-option]');
        if (optLabel) optLabel.addEventListener('click', function (e) {
          if (config.auto_advance === false || input.value === 'other' || !nextBtn) return;
          var pointer = (typeof e.pointerType === 'string') ? e.pointerType !== '' : e.detail > 0;
          if (!pointer) return;
          if (advanceTimer) window.clearTimeout(advanceTimer);
          var delay = prefersReducedMotion() ? 120 : 260;
          advanceTimer = window.setTimeout(function () {
            advanceTimer = null;
            if (!qEl.hidden && input.checked && !nextBtn.disabled) nextBtn.click();
          }, delay);
        });
      });

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var checked = qEl.querySelector('[data-quiz-option-input]:checked');
          if (!checked) return;
          var answer = checked.value;
          var prevAt = state.perQuestionAt[state.perQuestionAt.length - 1];
          var optDef = null;
          try {
            var qOpts = (questions[qIndex] && questions[qIndex].options) || [];
            for (var oi = 0; oi < qOpts.length; oi++) { if (qOpts[oi].tag === answer) { optDef = qOpts[oi]; break; } }
          } catch (_) { /* answers still work tag-only */ }
          var otherInputEl = qEl.querySelector('[data-quiz-other-input]');
          var otherText = (answer === 'other' && otherInputEl) ? otherInputEl.value.trim().slice(0, 120) : '';
          state.answers[qIndex] = { key: questions[qIndex].key, tag: answer, opt: optDef, otherText: otherText || null };
          track('gift_quiz_question_answered', {
            question_index: qIndex,
            question_key: questions[qIndex].key,
            answer_tag: answer,
            duration_ms_since_prev: Date.now() - prevAt
          });

          var nxt = nextVisibleIndex(qIndex);
          if (nxt !== null) {
            goToQuestion(nxt);
          } else {
            completeQuiz();
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var prv = prevVisibleIndex(qIndex);
          if (prv !== null) goToQuestion(prv);
        });
      }

      /* Skip (2026-08-24): "don't care" is honest signal — forcing an answer
         pollutes the data with lies and costs completions. Records the axis
         as neutral and advances; a skip on the LAST question completes. */
      if (questions[qIndex] && questions[qIndex].key === 'buyer_type') return; /* the fork is never skipped (Opus review M7) */
      var skipBtn = document.createElement('button');
      skipBtn.type = 'button';
      skipBtn.className = 'gift-quiz__skip';
      skipBtn.setAttribute('data-quiz-skip', '');
      skipBtn.textContent = 'skip this one';
      var navRow = qEl.querySelector('[data-quiz-next]') ? qEl.querySelector('[data-quiz-next]').parentElement : null;
      if (navRow && navRow.parentElement) navRow.parentElement.appendChild(skipBtn);
      skipBtn.addEventListener('click', function () {
        fireStartedOnce();
        state.answers[qIndex] = { key: questions[qIndex].key, tag: 'any', opt: null, skipped: true };
        track('gift_quiz_question_skipped', { question_index: qIndex, question_key: questions[qIndex].key });
        var nxt = nextVisibleIndex(qIndex);
        if (nxt !== null) { goToQuestion(nxt); } else { completeQuiz(); }
      });
    });

    /* Adaptive branching (2026-08-24): a question block may declare
       show_if "key:tag" (e.g. "buyer_type:gift") — it renders only when a
       PRIOR answer matches. Skipped questions are dropped from navigation
       and their progress segment marked complete. */
    function questionVisible(idx) {
      var q = questions[idx];
      if (state.answers[idx] && state.answers[idx].locked) return false;
      if (!q || !q.show_if) return true;
      var parts = String(q.show_if).split(':');
      if (parts.length !== 2) return true;
      return state.answers.some(function (a) {
        if (!a || a.key !== parts[0]) return false;
        return a.tag === parts[1] || (parts[1] === 'gift' && isGiftTag(a.tag));
      });
    }
    function nextVisibleIndex(from) {
      for (var i = from + 1; i < questionNodes.length; i++) { if (questionVisible(i)) return i; }
      return null;
    }
    function prevVisibleIndex(from) {
      for (var i = from - 1; i >= 0; i--) { if (questionVisible(i)) return i; }
      return null;
    }

    function updateStep(idx, visIdx) {
      var stepEl = root.querySelector('[data-quiz-step]');
      if (!stepEl) return;
      if (!visIdx) { visIdx = []; for (var vi = 0; vi < questionNodes.length; vi++) { if (questionVisible(vi)) visIdx.push(vi); } }
      /* before the branch question is decidable, count the branch once (gift OR self) */
      var plain = 0, branched = false;
      questions.forEach(function (q, qi) { if (state.answers[qi] && state.answers[qi].locked) return; if (q && q.show_if) branched = true; else plain++; });
      var total = Math.max(visIdx.length, plain + (branched ? 1 : 0));
      stepEl.textContent = visIdx.indexOf(idx) === -1 ? '' : (visIdx.indexOf(idx) + 1) + ' of ' + total;
    }
    function goToQuestion(idx, opts) {
      opts = opts || {};
      questionNodes.forEach(function (n, i) {
        n.hidden = i !== idx;
        n.classList.toggle('is-active', i === idx);
      });
      /* Branch-aware progress (2026-08-24): segments for questions the current
         branch skips are HIDDEN (never shown as completed work), and visible
         legends renumber to "Question n of m" over the visible set. */
      var visIdx = [];
      for (var vi = 0; vi < questionNodes.length; vi++) { if (questionVisible(vi)) visIdx.push(vi); }
      updateStep(idx, visIdx);
      progressNodes.forEach(function (n, i) {
        var vis = visIdx.indexOf(i) !== -1;
        n.style.display = vis ? '' : 'none';
        n.classList.toggle('is-active', i === idx);
        n.classList.toggle('is-complete', vis && visIdx.indexOf(i) < visIdx.indexOf(idx));
        n.setAttribute('aria-current', i === idx ? 'step' : 'false');
      });
      questionNodes.forEach(function (n, i) {
        var counter = n.querySelector('.gift-quiz__question-counter');
        var pos = visIdx.indexOf(i);
        if (counter && pos !== -1) counter.textContent = 'Question ' + (pos + 1) + ' of ' + visIdx.length;
      });
      /* Branch-aware final CTA: the last VISIBLE question closes with the
         match reveal; the label follows the buyer (never a hardcoded "her"). */
      var isSelf = state.answers.some(function (a) { return a && a.key === 'buyer_type' && a.tag === 'self'; });
      questionNodes.forEach(function (n, i) {
        var btn = n.querySelector('[data-quiz-next]');
        var pos = visIdx.indexOf(i);
        if (!btn || pos === -1) return;
        /* Labels live in Liquid-rendered data attributes so localization /
           merchant copy can never be clobbered by this rewrite. */
        var next = btn.getAttribute('data-label-next') || 'Continue \u2192';
        var fin = (isSelf && btn.getAttribute('data-label-final-self')) || btn.getAttribute('data-label-final') || 'See the match';
        btn.textContent = (pos === visIdx.length - 1) ? fin : next;
      });
      state.currentIndex = idx;
      state.perQuestionAt.push(Date.now());

      /* If an option is already checked (e.g., coming back from edit-answers "Change"),
         re-enable the Continue button so the buyer isn't blocked by a stale disabled state. */
      var targetEl = questionNodes[idx];
      if (targetEl) {
        var checked = targetEl.querySelector('[data-quiz-option-input]:checked');
        var nextBtn = targetEl.querySelector('[data-quiz-next]');
        if (nextBtn) nextBtn.disabled = !checked;
      }

      var legend = questionNodes[idx].querySelector('.gift-quiz__question-text');
      if (legend && !opts.noFocus) { legend.setAttribute('tabindex', '-1'); legend.focus({ preventScroll: false }); }
    }

    /* ——— Strip leads (2026-09-09): the same row carries the saved match ——— */
    function showBandReturning(product, savedObj) {
      if (!bandWelcome || !product) return;
      state.bandReturn = { saved: savedObj, product: product };
      if (bwProduct) bwProduct.textContent = product.title;
      if (bandLead) bandLead.hidden = true;
      bandWelcome.hidden = false;
      if (expandBtn) expandBtn.hidden = true;
      if (bwView) bwView.hidden = false;
      if (bwRetake) bwRetake.hidden = false;
      root.classList.add('is-returning');
      if (bwWired) return;
      bwWired = true;
      if (bwView) bwView.addEventListener('click', function () {
        var r = state.bandReturn;
        openBand({ returning: true, noFocus: true });
        if (r) showResultFromSavedWired(r.saved, r.product);
        /* the activated control is now hidden with the strip: move focus onto the result
           (Codex adversarial review 2026-09-09, HIGH) */
        var target = resultEl && !resultEl.hidden ? (resultEl.querySelector('.gift-quiz__primary-title') || resultEl) : null;
        if (target) { target.setAttribute('tabindex', '-1'); try { target.focus({ preventScroll: true }); } catch (_) {} }
      });
      if (bwRetake) bwRetake.addEventListener('click', function () {
        resetQuiz();            /* answers, radios, result, marks — the whole thing (Opus review H1) */
        showBandDefault();
        track('gift_quiz_restarted', {});
        openBand({ returning: true });
      });
    }
    function showBandDefault() {
      state.bandReturn = null;
      if (bandWelcome) bandWelcome.hidden = true;
      if (bandLead) bandLead.hidden = false;
      if (expandBtn) expandBtn.hidden = false;
      if (bwView) bwView.hidden = true;
      if (bwRetake) bwRetake.hidden = true;
      root.classList.remove('is-returning');
    }

    /* ——— Band: expand in place / collapse / Esc / impression (2026-09-08) ——— */
    function openBand(opts) {
      opts = opts || {};
      if (!isBand || !bodyEl) return;
      var wasOpen = root.classList.contains('is-open');
      root.classList.add('is-open');
      if (bandEl) bandEl.hidden = true;
      bodyEl.hidden = false;
      if (expandBtn) expandBtn.setAttribute('aria-expanded', 'true');
      if (bwView) bwView.setAttribute('aria-expanded', 'true');
      if (!wasOpen) track('gift_quiz_expand', { returning: !!opts.returning });
      if (!opts.noScroll) root.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      if (!opts.noFocus) {
        var active = questionNodes[state.currentIndex] && !questionNodes[state.currentIndex].hidden ? questionNodes[state.currentIndex] : null;
        var legend = active ? active.querySelector('.gift-quiz__question-text') : null;
        if (legend) { legend.setAttribute('tabindex', '-1'); try { legend.focus({ preventScroll: true }); } catch (_) {} }
      }
    }
    function closeBand() {
      if (!isBand || !bodyEl) return;
      root.classList.remove('is-open');
      bodyEl.hidden = true;
      if (bandEl) bandEl.hidden = false;
      /* a match found in this session travels back into the strip (saved by completeQuiz) */
      var sv = loadSaved();
      var mp = sv && sv.handle ? (products.find(function (p) { return p.handle === sv.handle; }) || (fallback && fallback.handle === sv.handle ? fallback : null)) : null;
      if (mp) showBandReturning(mp, sv);
      if (expandBtn) expandBtn.setAttribute('aria-expanded', 'false');
      if (bwView) bwView.setAttribute('aria-expanded', 'false');
      var focusTo = expandBtn && !expandBtn.hidden ? expandBtn : bwView;
      if (focusTo) { try { focusTo.focus({ preventScroll: true }); } catch (_) {} }
      track('gift_quiz_collapse', { at_question_index: state.currentIndex, had_result: !!state.lastResult });
    }
    updateStep(firstVisibleIndex());
    if (expandBtn) expandBtn.addEventListener('click', function () { openBand(); });
    /* "Take the quiz" anchors that predate the band (#gift-quiz on the Mother's Day
       hero) must open the finder, not land on a closed teaser (code review MEDIUM). */
    function hashOpens() { return !!root.id && location.hash === '#' + root.id; }
    if (hashOpens()) openBand({ noFocus: true });
    on(window, 'hashchange', function () { if (hashOpens()) openBand(); });
    on(document, 'click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || root.contains(a)) return;
      var href = a.getAttribute('href') || '';
      if (root.id && href.charAt(0) === '#' && href.slice(1) === root.id) openBand();
    });
    if (collapseBtn) collapseBtn.addEventListener('click', closeBand);
    if (isBand) {
      on(document, 'keydown', function (e) {
        if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
        if (document.querySelector('[data-cdw].is-open')) return; /* the drawer owns Esc while open */
        closeBand();
      });
      if (bandEl && typeof IntersectionObserver === 'function') {
        var impressionIO = watch(new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.5) { track('gift_quiz_impression', {}); impressionIO.disconnect(); }
          });
        }, { threshold: [0.5] }));
        impressionIO.observe(bandEl);
      }
    }
    if (keepBrowsing) {
      keepBrowsing.addEventListener('click', function (e) {
        e.preventDefault();
        var grid = document.querySelector('.product-list--collection, [data-cf-grid], .product-list');
        if (grid) grid.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        track('gift_quiz_keep_browsing', {});
      });
    }

    function completeQuiz() {
      /* Drop answers from questions the current branch never shows (a buyer who
         went back and flipped Q1 leaves the other branch's answer behind). */
      state.answers = state.answers.map(function (a, i) { return a && (a.locked || questionVisible(i)) ? a : null; });

      var ranked = scoreCandidates(products, state.answers);
      state.consideredCount = ranked.length; // L7: the count AFTER the budget filter
      var primary = ranked[0];
      var alternates = ranked.slice(1, 3);
      var ladder = config.scoring_engine === 'ladder';
      if (ladder) {
        var comp = composeLadder(ranked);
        primary = comp.primary; alternates = comp.alternates;
        state.stepUp = comp.stepUp; state.addOn = comp.addOn;
      }
      var stepEl0 = root.querySelector('[data-quiz-step]'); if (stepEl0) stepEl0.textContent = '';

      var threshold = typeof config.weak_match_threshold === 'number' ? config.weak_match_threshold : 1; // L3: 0 is a real value
      /* ladder mode resolved its primary (and its fallback) INSIDE composeLadder, so the step-up and
         add-on always belong to the displayed match (Codex Sol HIGH, 2026-09-09) */
      if (!ladder && (!primary || primary.score <= threshold)) {
        /* The fallback obeys the same laws as the pool (2026-09-05): never a
           sold-out product, never one outside the buyer's stated budget. */
        var fbOk = fallback && fallback.available !== false && fallbackWithinBudget(fallback);
        if (fbOk) {
          /* L4: the true best match stays visible as the first alternate
             instead of vanishing behind the merchant fallback — minus the
             fallback itself, which must not appear twice. */
          alternates = ranked.filter(function (c) { return c.product.handle !== fallback.handle; }).slice(0, 2);
          primary = { product: fallback, score: 0, isFallback: true };
        }
      }

      if (!primary || !primary.product) {
        hideAllQuestions();
        resultEl.hidden = false;
        clearEl(primaryEl);
        var fallbackMsg = document.createElement('p');
        fallbackMsg.className = 'gift-quiz__primary-rationale';
        fallbackMsg.setAttribute('tabindex', '-1');
        fallbackMsg.setAttribute('data-quiz-dead-end', '');
        fallbackMsg.textContent = state.noTub
          ? 'Everything on this page needs a tub. The shower rituals, candles and aromatherapy live in the full range. '
          : 'We couldn\u2019t narrow it down enough here. Everything we make is one page away. ';
        var out = document.createElement('a');
        out.className = 'gift-quiz__textlink';
        out.href = config.browse_all_link || '/collections/all';
        out.setAttribute('data-quiz-browse-link', '');
        out.textContent = state.noTub ? 'Browse the full range' : 'Browse everything';
        fallbackMsg.appendChild(out);
        primaryEl.appendChild(fallbackMsg);
        var stepEl1 = root.querySelector('[data-quiz-step]'); if (stepEl1) stepEl1.textContent = '';
        try { fallbackMsg.focus({ preventScroll: true }); } catch (_) {}
        resultEl.scrollIntoView({ behavior: (prefersReducedMotion() ? 'auto' : 'smooth'), block: 'start' });
        /* L5: the dead end is a completion too — without this event the path
           is analytics-invisible. */
        track('gift_quiz_completed', {
          quiz_id: config.quiz_id,
          matched_product_handle: null,
          dead_end: true,
          duration_ms_total: Date.now() - state.startedAt
        });
        return;
      }

      /* CAPTURE GATE (email_gate 'gate', 2026-08-24): the match is computed;
         the reveal waits one step for email+consent — with an always-available
         skip. Never gate twice (returning capture or prior skip). */
      if (config.email_gate === 'gate' && config.klaviyo_public_key && config.email_list_id && !state.gatePassed && gateEl) {
        state.pendingResult = { primary: primary, alternates: alternates };
        hideAllQuestions();
        gateEl.hidden = false;
        /* The gate's cost is only knowable if its exposure is counted:
           gate_shown → captured / skipped is the funnel the founder reads
           before deciding whether the gate stays (2026-09-05). */
        if (!state.gateShownTracked) {
          state.gateShownTracked = true;
          track('gift_quiz_gate_shown', { quiz_id: config.quiz_id });
          sendTelemetry({ event: 'gate_shown', matched_handle: primary.product.handle });
        }
        var gateHeading = gateEl.querySelector('[data-quiz-gate-heading]');
        if (gateHeading) { try { gateHeading.focus({ preventScroll: true }); } catch (_) {} }
        gateEl.scrollIntoView({ behavior: (prefersReducedMotion() ? 'auto' : 'smooth'), block: 'start' });
        return;
      }

      var totalDuration = Date.now() - state.startedAt;

      /* Unhide BEFORE rendering: DOM written into a hidden region is never
         announced, and un-hiding a container is not a live-region mutation. */
      hideAllQuestions();
      resultEl.hidden = false;
      renderPrimary(primary.product, primary.isFallback);
      renderAlternates(alternates.map(function (c) { return c.product; }));
      renderMeta(totalDuration, state.consideredCount || products.length);
      renderEditAnswers();

      state.lastAlternates = alternates.map(function (c) { return c.product.handle; });
      if (ladder) {
        renderStepUp(state.stepUp, primary.product);
        renderAddOn(state.addOn, primary.product);
      } else if (bundleEl && !primary.isFallback) renderPairs(primary.product);

      var klaviyoPayload = buildProfilePayload(primary.product, totalDuration);
      trackKlaviyo((config.quiz_name || 'Gift Quiz') + ' Completed', klaviyoPayload);

      track('gift_quiz_completed', {
        quiz_id: config.quiz_id,
        matched_product_handle: primary.product.handle,
        matched_product_title: primary.product.title,
        matched_product_price: primary.product.price,
        score: primary.score,
        is_fallback: !!primary.isFallback,
        alternate_handles: alternates.map(function (c) { return c.product.handle; }).join(','),
        duration_ms_total: totalDuration
      });

      state.lastResult = { primaryId: primary.product.id, altIds: alternates.map(function (c) { return c.product.id; }) };
      markGrid();
      observeGrid();
      armStrip(primary.product);
      if (!isGiftBuyer() && state.recipient) clearRecipient();
      if (recipientWrap) recipientWrap.hidden = !(config.recipient && config.recipient.enabled && isGiftBuyer());
      updateNamedEyebrow();
      hydrateGiftNoteFromCart();

      sendTelemetry({
        event: 'completed',
        answers: state.answers.filter(Boolean).map(function (a) {
          var out = { key: a.key, tag: a.tag };
          if (a.otherText) out.other_text = a.otherText;
          if (a.skipped) out.skipped = true;
          return out;
        }),
        matched_handle: primary.product.handle,
        is_fallback: !!primary.isFallback,
        duration_ms: totalDuration
      });

      /* Hide the returning-visitor welcome pill — once the buyer has
         completed a fresh quiz, showing the previous match pill beside
         the new result card is redundant and confusing. */
      if (welcomeEl) welcomeEl.hidden = true;

      savePersistence({
        quiz_id: config.quiz_id,
        engine: config.scoring_engine || 'tags',
        handle: primary.product.handle,
        answers: state.answers,
        recipient: state.recipient || '',
        collection_handle: config.collection_handle || null,
        ts: Date.now()
      });

      if (emailForm && !state.emailFormWired) { state.emailFormWired = true; wireEmailForm(primary.product); }

      focusResult();
    }

    /* Move focus to the result eyebrow so keyboard and screen-reader users
       land on the match (the region is not live; focus IS the announcement).
       :focus outline is suppressed on this element, so mouse users see
       nothing — the old "visible ring for mouse users" objection is moot. */
    function focusResult() {
      /* the TITLE, so a screen reader hears the product, not the eyebrow */
      var target = resultEl.querySelector('.gift-quiz__primary-title') || resultEl.querySelector('[data-quiz-result-eyebrow]');
      if (target) { target.setAttribute('tabindex', '-1'); try { target.focus({ preventScroll: true }); } catch (_) {} }
      resultEl.scrollIntoView({ behavior: (prefersReducedMotion() ? 'auto' : 'smooth'), block: 'start' });
    }

    function fallbackWithinBudget(fb) {
      var b = state.budget || {};
      if (typeof fb.price !== 'number') return true;
      if (b.max !== null && b.max !== undefined && fb.price > b.max) return false;
      if (b.min !== null && b.min !== undefined && fb.price < b.min) return false;
      return true;
    }

    function buildProfilePayload(product, durationMs) {
      /* Mirror answers to flat profile properties for Klaviyo segmentation.
         Phase 1: pushed to Klaviyo via klaviyo.push(['identify']) / ['track'].
         Phase 2 (deferred): same shape posts to the app proxy at /apps/quiz/profile. */
      var pref = { scent_pref: null, price_pref: null, persona_pref: null, peace_pref: null, recipient_pref: null, buyer_type: null, gift_occasion: null, concern_pref: null, ritual_pref: null };
      state.answers.forEach(function (a) {
        if (!a) return;
        if (a.key === 'buyer_type')  { pref.buyer_type = isGiftTag(a.tag) ? 'gift' : a.tag; pref.gift_recipient = isGiftTag(a.tag) ? a.tag : null; }
        if (a.key === 'occasion')    pref.gift_occasion = a.tag;
        if (a.key === 'concern')     pref.concern_pref  = a.tag;
        if (a.key === 'ritual')      pref.ritual_pref   = a.tag;
        if (a.key === 'scent' || a.key === 'scent_tags')   pref.scent_pref   = a.tag;
        if (a.key === 'price' || a.key === 'price_tier')   pref.price_pref   = a.tag;
        if (a.key === 'gift_persona') pref.persona_pref = a.tag;
        if (a.key === 'peace_tags')   pref.peace_pref   = a.tag;
        if (a.key === 'recipient_fit') pref.recipient_pref = a.tag;
      });
      return {
        quiz_id: config.quiz_id,
        quiz_name: config.quiz_name,
        matched_handle: product.handle,
        matched_title: product.title,
        matched_price_cents: product.price,
        last_match_handle: product.handle,
        last_quiz_id: config.quiz_id,
        last_quiz_at: new Date().toISOString(),
        scent_pref: pref.scent_pref,
        price_pref: pref.price_pref,
        persona_pref: pref.persona_pref,
        peace_pref: pref.peace_pref,
        recipient_pref: pref.recipient_pref,
        buyer_type: pref.buyer_type,
        gift_recipient: pref.gift_recipient,
        gift_occasion: pref.gift_occasion,
        occasion_fit: config.occasion_default_answer || null,
        duration_ms: durationMs
      };
    }

    function hideAllQuestions() {
      questionNodes.forEach(function (n) { n.hidden = true; n.classList.remove('is-active'); });
    }

    /* ——— The ladder engine (2026-09-09) ———
       Built from 323 real gift notes + the catalogue map: hard goods win every occasion,
       purpose-built sets win get-well and new-baby, gift AOV sits at $70–100 with half of
       gift orders over $100. relevance answers "is it right"; value answers "is it the
       strongest honest answer in the band". Budget is a BAND, not a ceiling. */
    function parseJsonSetting(str, fallbackValue) {
      if (!str) return fallbackValue;
      try { var v = JSON.parse(str); return v == null ? fallbackValue : v; } catch (_) { return fallbackValue; }
    }
    var valueAnchors = parseJsonSetting(config.value_anchors_json, []);
    if (!Array.isArray(valueAnchors)) valueAnchors = [];
    var otherKeywords = parseJsonSetting(config.other_keywords_json, {});
    function isHardware(p) { return /pillow|tray|caddy/i.test(String(p.type || '')) || /pillow|tray|caddy/i.test(String(p.handle || '')); }
    function needsTub(p) { var t = Array.isArray(p && p.tags_flat) ? p.tags_flat : []; return !!p && (isHardware(p) || t.indexOf('ritual-bath') !== -1 || t.indexOf('cat-bath') !== -1); }
    function isSetProduct(p) { return Array.isArray(p.tags_flat) && p.tags_flat.indexOf('cat-set') !== -1; }
    /* "Something else" text → an occasion tag via the merchant keyword map */
    var CONCERN_KEYWORDS = { 'sleep|insomnia|bedtime|tired': 'sleep', 'stress|anx|overwhelm|burn': 'stress', 'energy|morning|wake|focus|sluggish': 'energy', 'sore|muscle|workout|ache|back|recover': 'recovery' };
    function deriveFromMap(text, map) {
      if (!text) return null;
      var t = String(text).toLowerCase(), keys = Object.keys(map || {});
      for (var i = 0; i < keys.length; i++) {
        try { if (new RegExp(keys[i], 'i').test(t)) return map[keys[i]]; } catch (_) {}
      }
      return null;
    }
    function derivedOccasion(text) { return deriveFromMap(text, otherKeywords); }
    function scoreLadder(pool, answers) {
      var occasionMap = parseJsonSetting(config.occasion_map_json, {});
      var band = { min: null, max: null }, ritualTag = null, giftBuyer = false;
      answers.forEach(function (a) {
        if (!a || !a.opt) return;
        if (a.key === 'price') { if (typeof a.opt.min_cents === 'number') band.min = a.opt.min_cents; if (typeof a.opt.max_cents === 'number') band.max = a.opt.max_cents; }
        if (a.key === 'ritual') ritualTag = a.tag;
        if (a.key === 'buyer_type' && isGiftTag(a.tag)) giftBuyer = true;
      });
      state.band = band;
      state.budget = { max: band.max !== null ? Math.round(band.max * 1.25) : null, min: null };
      var noTub = !!(ritualTag && ritualTag !== 'bath' && ritualTag !== 'any');
      /* the no-tub rule is HARD (Codex Sol HIGH, 2026-09-09): a buyer who said "showers only" or
         "no water" is never shown anything that needs a tub — an empty pool is an honest dead end
         with a way out, not a quiet fallback to bath products */
      state.noTub = noTub;
      var applyNoTub = noTub;
      var ranked = [];
      pool.forEach(function (p) {
        var ptags = Array.isArray(p.tags_flat) ? p.tags_flat : [];
        var price = typeof p.price === 'number' ? p.price : null;
        if (band.max !== null && price !== null && price > band.max * 1.25) return;
        if (applyNoTub && needsTub(p)) return; /* no tub → nothing that needs one (tag-based, Opus review C1) */
        var relevance = 0, value = 0;
        answers.forEach(function (a) {
          if (!a || !a.opt || a.key === 'price') return;
          if (a.key === 'buyer_type') {
            var rm = Array.isArray(a.opt.match) ? a.opt.match : [];
            for (var r = 0; r < rm.length; r++) { if (ptags.indexOf(rm[r]) !== -1) { relevance += 1; break; } }
            return;
          }
          var tag = a.tag, opt = a.opt;
          if (tag === 'other' && (a.key === 'occasion' || a.key === 'concern')) {
            var derived = a.key === 'occasion' ? derivedOccasion(a.otherText) : deriveFromMap(a.otherText, CONCERN_KEYWORDS);
            if (derived) {
              tag = derived;
              var q = questions.find(function (qq) { return qq.key === a.key; });
              var dOpt = q && (q.options || []).find(function (o) { return o && o.tag === derived; });
              opt = dOpt || { match: [] };
            }
          }
          if (tag === 'any' || tag === 'other') return;
          var handles = Array.isArray(opt.handles) ? opt.handles : (occasionMap[tag] || null);
          var curated = !!(handles && handles.indexOf(p.handle) !== -1);
          var m = Array.isArray(opt.match) ? opt.match : [], hit = 0;
          for (var i = 0; i < m.length; i++) { if (ptags.indexOf(m[i]) !== -1) hit++; }
          if (a.key === 'occasion') { if (curated) relevance += 3; else if (hit) relevance += 2; }
          else if (a.key === 'concern') { if (curated) relevance += 2; else if (hit) relevance += 2; }
          else if (hit || curated) relevance += 1;
        });
        if (price !== null && band.min !== null && price < band.min) value -= 1.5;
        if (price !== null && band.max !== null && price > band.max) value -= 0.5;
        if (p.is_bestseller) value += 1;
        if (valueAnchors.indexOf(p.handle) !== -1) value += 1;
        if (giftBuyer && isSetProduct(p)) value += 1;
        ranked.push({ product: p, score: relevance + value, relevance: relevance, value: value, anchor: valueAnchors.indexOf(p.handle) !== -1, inBand: price === null ? true : ((band.min === null || price >= band.min) && (band.max === null || price <= band.max)) });
      });
      var SWEET_SPOT = 9000; /* the $70–100 band holds 35% of gift orders (323 notes, 2026-09-09) */
      var noBand = band.min === null && band.max === null;
      ranked.sort(function (a, b) {
        /* band first, relevance second, value third: the anchors and the bestseller nudge decide
           only among equally relevant products — a value point never outranks a real signal */
        var abi = a.inBand ? 1 : 0, bbi = b.inBand ? 1 : 0;
        if (bbi !== abi) return bbi - abi;
        if (b.relevance !== a.relevance) return b.relevance - a.relevance;
        if (b.score !== a.score) return b.score - a.score;
        var ap = a.product.price || 0, bp = b.product.price || 0;
        /* equal footing: inside a band the stronger gift wins; with no band ("Surprise me")
           the one nearest the sweet spot wins — never simply the dearest (Opus review M6) */
        if (noBand) { var da = Math.abs(ap - SWEET_SPOT), db = Math.abs(bp - SWEET_SPOT); if (da !== db) return da - db; }
        else if (bp !== ap) return bp - ap;
        if ((b.product.review_count || 0) !== (a.product.review_count || 0)) return (b.product.review_count || 0) - (a.product.review_count || 0);
        var ai = a.product.in_collection === false ? 0 : 1, bi = b.product.in_collection === false ? 0 : 1;
        return bi - ai;
      });
      return ranked;
    }
    /* primary → step-up → add-on → one second opinion */
    function composeLadder(ranked) {
      var primary = ranked[0] && ranked[0].relevance >= 2 ? ranked[0] : null;
      if (!primary) {
        var anchorInBand = ranked.find(function (c) { return c.anchor && c.inBand; }) || ranked.find(function (c) { return c.anchor; });
        if (anchorInBand) primary = { product: anchorInBand.product, score: anchorInBand.score, relevance: anchorInBand.relevance, isFallback: true };
        else if (fallback && fallback.available !== false && fallbackWithinBudget(fallback) && !(state.noTub && needsTub(fallback))) primary = { product: fallback, score: 0, relevance: 0, isFallback: true };
        else primary = ranked[0] || null;
      }
      if (!primary) return { primary: null, alternates: [], stepUp: null, addOn: null };
      var pp = primary.product, price = pp.price || 0, used = {};
      used[pp.handle] = true;
      var stepUp = ranked.find(function (c) {
        var cp = c.product.price || 0;
        return !used[c.product.handle] && cp >= price * 1.25 && cp <= price * 3 && c.relevance >= Math.max(0, (primary.relevance || 0) - 1) && (c.anchor || isSetProduct(c.product));
      }) || null;
      if (stepUp) used[stepUp.product.handle] = true;
      /* curated partners obey the same laws as the pool (Opus review C2): resolved through the
         RANKED list (band ceiling + no-tub rule already applied) and never dearer than the match */
      var partners = (Array.isArray(pp.bundle_partners) ? pp.bundle_partners : []).map(function (bp) {
        if (!bp || !bp.handle || used[bp.handle]) return null;
        var c = ranked.find(function (cc) { return cc.product.handle === bp.handle && cc.product.variant_id; });
        return c && (c.product.price || 0) <= price ? c.product : null;
      }).filter(Boolean);
      var addOnProduct = partners[0] || null;
      if (!addOnProduct) {
        var wantHardware = !isHardware(pp);
        var ritualA = state.answers.find(function (a) { return a && a.key === 'ritual'; });
        var noTub = ritualA && ritualA.tag !== 'bath' && ritualA.tag !== 'any';
        var cands = ranked.filter(function (c) {
          var p2 = c.product;
          if (used[p2.handle] || !p2.variant_id) return false;
          if (wantHardware && noTub) return false;
          if (wantHardware !== isHardware(p2)) return false;
          if (p2.type === 'Mandala Tapestry') return false;
          return (p2.price || 0) <= price;
        });
        cands.sort(function (a, b) { return (b.value - a.value) || ((b.product.price || 0) - (a.product.price || 0)); });
        addOnProduct = cands[0] ? cands[0].product : null;
      }
      if (addOnProduct) used[addOnProduct.handle] = true;
      var alternate = ranked.find(function (c) { return !used[c.product.handle] && c.relevance >= 1; }) || ranked.find(function (c) { return !used[c.product.handle]; }) || null;
      return { primary: primary, alternates: alternate ? [alternate] : [], stepUp: stepUp ? stepUp.product : null, addOn: addOnProduct };
    }
    function ladderCard(product, kind, ctaLabel, onCta, subline, quiet) {
      var card = document.createElement('div');
      card.className = 'gift-quiz__ladder-card gift-quiz__ladder-card--' + kind;
      var imgWrap = document.createElement('a'); imgWrap.className = 'gift-quiz__ladder-img'; imgWrap.href = product.url || '#';
      if (product.image) { var img = document.createElement('img'); img.src = product.image; img.alt = product.image_alt || product.title || ''; img.loading = 'lazy'; imgWrap.appendChild(img); }
      card.appendChild(imgWrap);
      var body = document.createElement('div'); body.className = 'gift-quiz__ladder-body';
      var title = document.createElement('p'); title.className = 'gift-quiz__ladder-title'; title.textContent = product.title || ''; body.appendChild(title);
      var priceEl = document.createElement('p'); priceEl.className = 'gift-quiz__ladder-price'; priceEl.textContent = subline || product.price_formatted || ''; body.appendChild(priceEl);
      var ctas = document.createElement('div'); ctas.className = 'gift-quiz__ladder-ctas';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = quiet ? 'gift-quiz__textlink' : ('gift-quiz__ladder-cta' + (kind === 'addon' ? ' gift-quiz__ladder-cta--ink' : '')); btn.textContent = ctaLabel;
      btn.setAttribute('data-quiz-' + kind + '-cta', '');
      btn.addEventListener('click', onCta); ctas.appendChild(btn);
      var view = document.createElement('a'); view.className = 'gift-quiz__textlink gift-quiz__textlink--muted'; view.href = product.url || '#'; view.textContent = 'View'; ctas.appendChild(view);
      body.appendChild(ctas); card.appendChild(body);
      return card;
    }
    function renderStepUp(product, primary) {
      var wrap = root.querySelector('[data-quiz-stepup]'), slot = root.querySelector('[data-quiz-stepup-card]');
      if (!wrap || !slot) return;
      clearEl(slot);
      if (!product) { wrap.hidden = true; return; }
      var diff = (product.price || 0) - (primary.price || 0);
      var sub = (product.price_formatted || '') + (diff > 0 ? ' \u00b7 ' + formatMoney(diff) + ' more than the match' : '');
      slot.appendChild(ladderCard(product, 'stepup', 'Choose this instead', function () {
        track('gift_quiz_stepup_add', { quiz_id: config.quiz_id, handle: product.handle, from_handle: primary.handle });
        addToBag(product, 'stepup');
      }, sub));
      wrap.hidden = false;
    }
    function renderAddOn(product, primary) {
      if (!bundleEl || !bundleGrid) return;
      clearEl(bundleGrid);
      if (!product) { bundleEl.hidden = true; return; }
      var total = (product.price || 0) + (primary.price || 0);
      var already = !!((state.addedHandles && state.addedHandles[primary.handle]) || (state.inCart && primary.variant_id && state.inCart[primary.variant_id]));
      bundleGrid.appendChild(ladderCard(product, 'addon', already ? ('Add it \u00b7 ' + (product.price_formatted || '')) : ('Add both \u00b7 ' + formatMoney(total)), function () {
        if (addBusy) return;
        /* the bag is re-read at the tap (another tab, a PDP add, a reload): a match already in
           the bag is never sent again (Codex Sol HIGH, 2026-09-09) */
        readCart().then(function (cart) {
          if (cart) noteCartLines(cart);
          var inBag = !!((state.addedHandles && state.addedHandles[primary.handle]) || (state.inCart && primary.variant_id && state.inCart[primary.variant_id]));
          if (inBag) { addToBag(product, 'pair'); return; }
          track('gift_quiz_add_both', { quiz_id: config.quiz_id, handle: product.handle, with_handle: primary.handle, total_cents: total });
          addManyToBag([{ product: primary, slot: 'primary' }, { product: product, slot: 'pair' }]);
        });
      }, '+ ' + (product.price_formatted || '')));
      bundleEl.hidden = false;
      state.addOnProduct = product;
    }
    function noteAdded(product) {
      state.addedHandles = state.addedHandles || {};
      state.addedHandles[product.handle] = true;
      var cta = root.querySelector('[data-quiz-addon-cta]');
      if (cta && state.addOnProduct && state.lastResult && product.id === state.lastResult.primaryId) cta.textContent = 'Add it \u00b7 ' + (state.addOnProduct.price_formatted || '');
    }
    /* one request, two lines (the drawer refreshes once) */
    function addManyToBag(items) {
      hideAddError();
      if (addBusy) return;
      addBusy = true;
      var sent = items.filter(function (it) { return it.product && it.product.variant_id; });
      var payload = { items: sent.map(function (it) {
        var props = { _gf_quiz: config.quiz_id || 'gift_quiz', _gf_session: state.sessionId, _gf_slot: it.slot, _gf_surface: surface };
        return { id: it.product.variant_id, quantity: 1, properties: props };
      }) };
      if (sent.length !== items.length || !sent.length) { addBusy = false; showAddError(items[0] && items[0].product, new Error('Could not add to bag')); return; }
      syncRecipientAttribute().then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) });
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error((d && d.description) || 'Could not add to bag'); });
        return res.json();
      }).then(function () {
        sent.forEach(function (it) { noteAdded(it.product); track('gift_quiz_add_to_bag', { quiz_id: config.quiz_id, matched_product_handle: it.product.handle, slot: it.slot, add_both: true }); });
        sendTelemetry({ event: 'add_to_bag', matched_handle: sent[0].product.handle, slot: 'add_both' });
        var drawer = document.querySelector('[data-section-type="cart-drawer"]');
        if (drawer) { document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart:open')); }
        else window.location.href = '/cart';
      }).catch(function (err) {
        showAddError(sent[0] && sent[0].product, err);
      }).then(function () { addBusy = false; });
    }

    function scoreCandidates(pool, answers) {
      if (config.scoring_engine === 'ladder') return scoreLadder(pool, answers);
      /* Plan §5 scoring priority:
           +2  occasion_fit match (via synthetic answer when occasion_default_answer is locked, OR via explicit Q)
           +2  recipient_fit match
           +1  peace_tags / saynoto_tags / scent_tags / gift_persona / ritual_time match
           Hard filter: price_tier > user_budget  → excluded
           +0.5 bestseller tiebreaker
           Review count breaks remaining ties. */
      var TIER_ORDER = { 'tier_50': 1, 'tier_100': 2, 'tier_150': 3, 'tier_signature': 4 };
      var HEAVY_KEYS = { occasion_fit: true, recipient_fit: true };

      var userBudget = null;
      answers.forEach(function (a) {
        if (a && a.key === 'price_tier' && a.tag !== 'any') userBudget = TIER_ORDER[a.tag];
      });

      /* Inject occasion_default_answer as a synthetic occasion_fit answer when set,
         so every product gets a +2 comparison even on occasion-locked templates. */
      var effectiveAnswers = answers.slice();
      if (config.occasion_default_answer) {
        var hasOccasionAnswer = effectiveAnswers.some(function (a) { return a && a.key === 'occasion_fit'; });
        if (!hasOccasionAnswer) {
          effectiveAnswers.push({ key: 'occasion_fit', tag: config.occasion_default_answer });
        }
      }

      /* TAGS ENGINE (scoring_engine: 'tags', 2026-08-24 personal-shopper rebuild):
         options carry `match` (an array of LITERAL Shopify tags — ritual-*, mood-*,
         cat-scent-*, cat-concern-*, gift-occasion-*), optional `handles` (a curated
         handle list — the occasion→sets map beats sparse occasion tags), and
         optional `max_cents` (a REAL price ceiling on product.price — the L1 fix:
         the metafield tier let unseeded products bypass the budget entirely).
         `buyer_type` answers route + capture; they never score. */
      var tagsEngine = config.scoring_engine === 'tags';
      var occasionMap = {};
      if (config.occasion_map_json) {
        try { occasionMap = JSON.parse(config.occasion_map_json) || {}; } catch (_) { occasionMap = {}; }
      }
      var maxCents = null, minCents = null;
      if (tagsEngine) {
        answers.forEach(function (a) {
          if (a && a.opt && typeof a.opt.max_cents === 'number') maxCents = a.opt.max_cents;
          if (a && a.opt && typeof a.opt.min_cents === 'number') minCents = a.opt.min_cents;
        });
      }
      state.budget = { max: maxCents, min: minCents };
      /* Gift buyers lean toward sets (2026-09-05 CRO wave): a boxed set is the
         gift-shaped answer, and 2+ line orders run +$56 AOV. One point — a
         nudge among equals, never an override of a real tag match. */
      var giftBuyer = answers.some(function (a) { return a && a.key === 'buyer_type' && isGiftTag(a.tag); });

      var ranked = [];
      pool.forEach(function (p) {
        var score = 0;
        if (tagsEngine) {
          var ptags = Array.isArray(p.tags_flat) ? p.tags_flat : [];
          if (maxCents !== null && typeof p.price === 'number' && p.price > maxCents) return; // hard budget ceiling on the REAL price
          if (minCents !== null && typeof p.price === 'number' && p.price < minCents) return; // budget floor — "a real gift" never returns a token item
          var isSet = giftBuyer && ptags.indexOf('cat-set') !== -1;
          effectiveAnswers.forEach(function (a) {
            if (!a || !a.opt) return;
            if (a.key === 'buyer_type') return;
            if (a.tag === 'any' || a.tag === 'other') { score += 1; return; }
            var matchedCount = 0;
            var m = Array.isArray(a.opt.match) ? a.opt.match : [];
            for (var i = 0; i < m.length; i++) { if (ptags.indexOf(m[i]) !== -1) matchedCount++; }
            var matched = matchedCount > 0;
            // Occasion: the curated handle map is authoritative (+2, the personal-
            // shopper move); occasion tags corroborate at +2 too.
            var handles = Array.isArray(a.opt.handles) ? a.opt.handles : (occasionMap[a.tag] || null);
            if (handles && handles.indexOf(p.handle) !== -1) { score += 2; return; }
            // Depth over flatness: a product matching MORE of the answer's tags
            // outranks a single-tag graze (capped +2 per question).
            if (matched) { score += (a.key === 'occasion' ? 2 : Math.min(matchedCount, 2)); }
          });
          /* the set nudge applies only to products that already matched an
             answer — it must never lift a zero-match product over the
             weak-match threshold and starve the curated fallback */
          if (isSet && score > 0) score += 1;
        } else {
          effectiveAnswers.forEach(function (a) {
            if (!a) return;
            var weight = HEAVY_KEYS[a.key] ? 2 : 1;
            if (a.tag === 'any' || a.tag === 'other') { score += weight; return; }
            var values = p.quiz ? p.quiz[a.key] : null;
            /* Product-side wildcard honored (L2 fix): a product tagged "any" on
               this axis matches every answer. */
            if (values === 'any' || (Array.isArray(values) && values.indexOf('any') !== -1)) { score += weight; return; }
            if (Array.isArray(values) && values.indexOf(a.tag) !== -1) { score += weight; return; }
            if (typeof values === 'string' && values === a.tag) { score += weight; return; }
          });

          if (userBudget) {
            state.budget = { max: ({ 1: 5000, 2: 10000, 3: 15000 })[userBudget] || null, min: null };
            if (p.quiz && p.quiz.price_tier) {
              var pt = TIER_ORDER[p.quiz.price_tier];
              if (pt && pt > userBudget) return;
            } else if (typeof p.price === 'number') {
              /* L1 fix: an unseeded product no longer bypasses the budget — its
                 REAL price is checked against the tier ceilings (cents). */
              var CEILING = { 1: 5000, 2: 10000, 3: 15000, 4: Infinity };
              if (p.price > (CEILING[userBudget] || Infinity)) return;
            }
          }
        }

        if (p.is_bestseller) score += 0.5;

        ranked.push({ product: p, score: score, considered: true });
      });

      ranked.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        /* a product on THIS page beats one pulled in from the wider range */
        var ai = a.product.in_collection === false ? 0 : 1, bi = b.product.in_collection === false ? 0 : 1;
        if (bi !== ai) return bi - ai;
        return (b.product.review_count || 0) - (a.product.review_count || 0);
      });

      return ranked;
    }

    /* Composes the verdict line from the buyer's answers. Phrase maps are
       keyed on the evergreen template's option tags; unknown tags fall back
       to the option label so a copy edit can never break the sentence. */
    function buildRationale() {
      var byKey = {};
      state.answers.forEach(function (a) { if (a && a.key) byKey[a.key] = a; });
      var bits = [];
      var OCC = { 'new-mom': 'a new baby at home', 'new-baby': 'a new baby at home', 'get-well': 'someone on the mend', 'sympathy': 'a hard season', 'birthday': 'a birthday', 'celebration': 'a moment worth marking', 'thanks': 'a thank-you', 'just-because': 'no occasion needed', 'new-home': 'a new home', 'anniversary': 'an anniversary', 'christmas': 'the holidays', 'mothers-day': "Mother's Day", 'fathers-day': "Father's Day", 'valentines': "Valentine's Day" };
      var CON = { 'sleep': 'better sleep', 'stress': 'less stress', 'energy': 'slow mornings', 'recovery': 'a body that worked hard' };
      var RIT = { 'bath': 'a proper bath night', 'shower': 'shower rituals only', 'no-water': 'no tub required', 'any': 'water optional' };
      var SCT = { 'lavender': 'leaning lavender', 'citrus': 'leaning citrus', 'eucalyptus': 'leaning eucalyptus', 'rose': 'leaning rose', 'any': 'scent left to us' };
      var PRC = { 'under-50': 'kept under $50', '50-100': 'a thoughtful budget', '100-150': 'the full set', 'about-50': 'a thoughtful gesture', 'about-90': 'the budget most people give', 'about-150': 'the full evening', 'all-in': 'all in', 'any': 'no ceiling' };
      if (byKey.occasion) bits.push(OCC[byKey.occasion.tag] || null);
      if (byKey.concern) bits.push(CON[byKey.concern.tag] || null);
      if (byKey.ritual) bits.push(RIT[byKey.ritual.tag] || null);
      if (byKey.scent) bits.push(SCT[byKey.scent.tag] || null);
      /* the budget is never echoed back at a gift buyer (Opus review H6); the tags engine keeps it */
      if (byKey.price && config.scoring_engine !== 'ladder') bits.push(PRC[byKey.price.tag] || null);
      bits = bits.filter(Boolean);
      /* the close borrows the buyers' own frame from 323 gift notes: "a little something
         to help you relax" — neutral by construction (a name, the recipient word, or "them") */
      var who = (state.recipient || '').trim() || recipientWord();
      var OCC_CLOSE = { 'sympathy': ' \u2014 something quiet, for a week that isn\u2019t.', 'get-well': ' \u2014 something gentle for the mend.', 'new-baby': ' \u2014 a pocket of rest in the newborn weeks.' };
      var occTag = byKey.occasion ? byKey.occasion.tag : null;
      var close = isGiftBuyer()
        ? (OCC_CLOSE[occTag] || (' \u2014 a little something to help ' + (who || 'them') + ' relax.'))
        : ' \u2014 an hour that is actually yours.';
      if (!bits.length) return 'Of everything here, this is the one we would walk you to' + close;
      var lead = bits.join(', ');
      return lead.charAt(0).toUpperCase() + lead.slice(1) + close;
    }

    /* ——— Safe DOM construction (NO innerHTML). Defense in depth. ——— */
    function clearEl(el) {
      while (el.firstChild) el.removeChild(el.firstChild);
    }

    function renderPrimary(product, isFallback) {
      clearEl(primaryEl);

      if (product.image) {
        var imgWrap = document.createElement('div');
        imgWrap.className = 'gift-quiz__primary-img';
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = product.image_alt || product.title || '';
        img.loading = 'eager';
        imgWrap.appendChild(img);
        primaryEl.appendChild(imgWrap);
      }

      var body = document.createElement('div');
      body.className = 'gift-quiz__primary-body';

      var title = document.createElement('h3');
      title.className = 'gift-quiz__primary-title';
      title.textContent = product.title || '';
      body.appendChild(title);

      var price = document.createElement('p');
      price.className = 'gift-quiz__primary-price';
      price.textContent = isFallback
        ? 'A safe, beloved choice · ' + (product.price_formatted || '')
        : (product.price_formatted || '');
      body.appendChild(price);
      if (product.in_collection === false && config.collection_handle) {
        var wider = document.createElement('p');
        wider.className = 'gift-quiz__wider-note';
        wider.textContent = 'From our wider range';
        body.appendChild(wider);
      }

      /* The personal-shopper verdict line: a curated metafield rationale
         wins; otherwise compose one from the buyer's own answers so the
         match always explains itself (founder brief 2026-08-24). */
      /* ladder mode composes its own line — the product metafield rationales predate the
         no-gendered-copy rule ("scented so she leaves…") and are not used there */
      var rationaleText = config.scoring_engine === 'ladder' ? buildRationale() : ((product.quiz && product.quiz.match_rationale) || product.rationale || buildRationale());
      if (rationaleText) {
        var rationale = document.createElement('p');
        rationale.className = 'gift-quiz__primary-rationale';
        rationale.textContent = rationaleText;
        body.appendChild(rationale);
      }

      /* Persuasion stack (2026-08-24 rebuild — the result is the highest-intent
         surface and previously carried none of this):
         - stars: the product's own count when it clears 50 reviews, else the
           brand-grain claim (the stars-by-grain law);
         - the delivery truth, verbatim;
         - the gift-ready line, only when the buyer said "gift". */
      var trust = document.createElement('div');
      trust.className = 'gift-quiz__trust';

      var proof = document.createElement('p');
      proof.className = 'gift-quiz__primary-proof';
      proof.textContent = (product.review_count && product.review_count >= 50)
        ? ('\u2605 Rated by ' + product.review_count + ' verified buyers')
        : (config.result_proof_line ? ('\u2605 ' + config.result_proof_line) : '');
      if (proof.textContent) trust.appendChild(proof);

      /* Both lines are merchant settings now (the proof + ship claims used to
         be hardcoded in JS with no owner); the arrival date is computed. */
      var ship = document.createElement('p');
      ship.className = 'gift-quiz__primary-ship';
      ship.textContent = config.result_ship_line || '';
      if (ship.textContent) trust.appendChild(ship);

      var arrival = arrivalLabel();
      if (arrival) {
        var arrivalEl = document.createElement('p');
        arrivalEl.className = 'gift-quiz__primary-arrival';
        arrivalEl.textContent = arrival;
        trust.appendChild(arrivalEl);
      }

      var isGiftBuyer = state.answers.some(function (a) { return a && a.key === 'buyer_type' && isGiftTag(a.tag); });
      if (isGiftBuyer) {
        var giftLine = document.createElement('p');
        giftLine.className = 'gift-quiz__primary-ship';
        giftLine.textContent = 'Arrives looking like a gift \u2014 nothing to wrap';
        trust.appendChild(giftLine);
      }
      body.appendChild(trust);

      var ctas = document.createElement('div');
      ctas.className = 'gift-quiz__primary-ctas';

      var atb = document.createElement('button');
      atb.type = 'button';
      atb.className = 'gift-quiz__btn gift-quiz__btn--primary';
      atb.textContent = 'Add to bag';
      atb.addEventListener('click', function () { addToBag(product, 'primary'); });
      ctas.appendChild(atb);

      if (product.url) {
        var view = document.createElement('a');
        view.className = 'gift-quiz__btn gift-quiz__btn--outline';
        view.href = product.url;
        view.textContent = 'View product';
        ctas.appendChild(view);
      }

      body.appendChild(ctas);
      primaryEl.appendChild(body);
    }

    function renderAlternates(list) {
      if (!alternatesEl) return;
      clearEl(alternatesEl);
      var wrap = root.querySelector('[data-quiz-alternates-wrap]');
      if (wrap) wrap.hidden = !list || !list.length;
      if (!list || !list.length) return;
      if (config.scoring_engine === 'ladder') {
        list.forEach(function (product) {
          if (!product) return;
          var card = ladderCard(product, 'alternate', 'Add to bag', function () {
            track('gift_quiz_alternate_add', { quiz_id: config.quiz_id, handle: product.handle });
            addToBag(product, 'alternate');
          }, null, true);
          var cta = card.querySelector('[data-quiz-alternate-cta]');
          if (cta) { cta.classList.add('gift-quiz__alternate-add'); cta.setAttribute('aria-label', 'Add ' + (product.title || 'this') + ' to bag'); }
          alternatesEl.appendChild(card);
        });
        return;
      }

      list.forEach(function (product) {
        if (!product) return;
        var card = document.createElement('div');
        card.className = 'gift-quiz__alternate';

        var a = document.createElement('a');
        a.className = 'gift-quiz__alternate-link';
        a.href = product.url || '#';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'gift-quiz__alternate-img';
        if (product.image) {
          var img = document.createElement('img');
          img.src = product.image;
          img.alt = product.image_alt || product.title || '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }
        a.appendChild(imgWrap);

        var body = document.createElement('div');
        body.className = 'gift-quiz__alternate-body';

        var title = document.createElement('h4');
        title.className = 'gift-quiz__alternate-title';
        title.textContent = product.title || '';
        body.appendChild(title);

        var price = document.createElement('p');
        price.className = 'gift-quiz__alternate-price';
        price.textContent = product.price_formatted || '';
        body.appendChild(price);
        a.appendChild(body);
        card.appendChild(a);

        /* Add to bag on the alternates (2026-09-05): a second opinion the
           buyer prefers used to be a click OUT of the funnel. */
        var ctas = document.createElement('div');
        ctas.className = 'gift-quiz__alternate-ctas';
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'gift-quiz__pair-add gift-quiz__alternate-add';
        add.textContent = '+ Add to bag';
        add.setAttribute('aria-label', 'Add ' + (product.title || 'this') + ' to bag');
        add.addEventListener('click', function () {
          track('gift_quiz_alternate_add', { quiz_id: config.quiz_id, handle: product.handle });
          addToBag(product, 'alternate');
        });
        ctas.appendChild(add);
        var view = document.createElement('a');
        view.className = 'gift-quiz__alternate-view';
        view.href = product.url || '#';
        view.textContent = 'View';
        ctas.appendChild(view);
        card.appendChild(ctas);

        alternatesEl.appendChild(card);
      });
    }

    function renderMeta(durationMs, consideredCount) {
      if (!metaEl) return;
      if (!durationMs || config.scoring_engine === 'ladder') { metaEl.hidden = true; return; }
      metaEl.hidden = false;
      var seconds = Math.max(1, Math.round(durationMs / 1000));
      var template = config.result_meta_template || 'Matched in {duration}s. {count} sets considered.';
      metaEl.textContent = template
        .replace('{duration}', String(seconds))
        .replace('{count}', String(consideredCount));
    }

    /* Recipient handoff (2026-09-08; one note 2026-09-14): the drawer reads the name
       out of cart.note's first line ("To Maya,") at render, so the note must land
       BEFORE cart:refresh. No order attributes — they duplicate into ShipStation's
       Note From Buyer. A failed update never blocks the add. */
    function syncRecipientAttribute() {
      var name = (state.recipient || '').trim().slice(0, 40);
      var message = (state.giftMessage || '').trim().slice(0, 300);
      /* only words the shopper typed HERE are written; words merely hydrated from the bag
         are re-read fresh (another surface may have changed them since) — a cleared,
         touched field clears the card */
      var writeMessage = !!state.giftMessageTouched;
      var stamp = name + '|' + message;
      /* '' clears a previously synced name (a cleared field must not leave the
         drawer saying "A gift for Maya"); nothing to do when nothing changed */
      if (stamp === (state.recipientSynced || '')) return Promise.resolve();
      var attempt = function () {
        var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctrl) { try { ctrl.abort(); } catch (_) {} } }, 4000);
        /* an untouched message field keeps the words the bag already carries (the
           drawer's, the builder's) — only the "To" line changes */
        var words = writeMessage
          ? Promise.resolve(message)
          : readCart().then(function (cart) { if (!cart) throw new Error('cart read'); return splitGiftNote(cart.note).message; });
        return words.then(function (w) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ note: joinGiftNote(name, w), attributes: RETIRED_GIFT_ATTRIBUTES }),
            signal: ctrl ? ctrl.signal : undefined
          });
        }).then(function (res) { clearTimeout(timer); if (!res.ok) throw new Error('update ' + res.status); state.recipientSynced = stamp; }, function (err) { clearTimeout(timer); throw err; });
      };
      /* one retry, then the add goes ahead regardless — a lost name is a lesser
         failure than a lost sale; the field stays filled so the next add retries */
      return attempt().catch(function () { return attempt(); }).catch(function () { /* proceed */ });
    }
    /* A name belongs to ONE gift path (code review HIGH, 2026-09-08): flipping to
       "for me", restarting or retaking clears it — and clears the synced cart
       attribute, so the drawer never says "A gift for Maya" for a different order. */
    function clearRecipient() {
      state.recipient = '';
      state.recipientNamedTracked = false;
      if (recipientInput) recipientInput.value = '';
      updateNamedEyebrow();
      if (state.recipientSynced) syncRecipientAttribute();
    }
    function updateNamedEyebrow() {
      if (!resultEyebrowEl) return;
      var name = (state.recipient || '').trim() || recipientWord();
      if (!name) { resultEyebrowEl.textContent = resultEyebrowDefault; return; }
      /* the eyebrow is all-caps by design; the name keeps its own case */
      var tpl = (config.recipient && config.recipient.named_eyebrow) || 'The match, for {name}';
      var parts = tpl.split('{name}');
      clearEl(resultEyebrowEl);
      resultEyebrowEl.appendChild(document.createTextNode(parts[0] || ''));
      var nm = document.createElement('span');
      nm.className = 'gift-quiz__eyebrow-name';
      nm.textContent = name;
      resultEyebrowEl.appendChild(nm);
      if (parts[1]) resultEyebrowEl.appendChild(document.createTextNode(parts[1]));
    }
    if (recipientInput) {
      recipientInput.addEventListener('input', function () {
        state.recipient = recipientInput.value.trim().slice(0, 40);
        updateNamedEyebrow();
        /* the name arrives AFTER the result was saved — keep the saved match in step so a
           reload (and the welcome-back view) carries "The match, for Maya" */
        if (state.lastResult) { var savedNow = loadSaved(); if (savedNow) { savedNow.recipient = state.recipient; savePersistence(savedNow); } }
        if (state.recipient && !state.recipientNamedTracked) { state.recipientNamedTracked = true; track('gift_quiz_recipient_named', {}); }
        scheduleNoteSync();
      });
      recipientInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); recipientInput.blur(); } });
    }

    function showAddError(product, err) {
      var host = resultEl || root;
      var line = host.querySelector('[data-quiz-add-status]');
      if (!line) {
        line = document.createElement('p');
        line.className = 'gift-quiz__add-status';
        line.setAttribute('data-quiz-add-status', '');
        line.setAttribute('role', 'alert');
        var anchor = host.querySelector('[data-quiz-primary]');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(line, anchor.nextSibling); else host.appendChild(line);
      }
      clearEl(line);
      var msg = (err && /sold out|unavailable/i.test(String(err.message))) ? 'That one just sold out \u2014 try a second opinion below.' : 'That didn\u2019t go through \u2014 try again, or ';
      line.appendChild(document.createTextNode(msg));
      if (!/sold out/i.test(msg) && product && product.url) {
        var a = document.createElement('a'); a.href = product.url; a.textContent = 'open the product'; line.appendChild(a); line.appendChild(document.createTextNode('.'));
      }
      line.hidden = false;
      track('gift_quiz_add_failed', { matched_product_handle: product && product.handle, reason: String(err && err.message || 'unknown').slice(0, 60) });
    }
    function hideAddError() { var line = (resultEl || root).querySelector('[data-quiz-add-status]'); if (line) line.hidden = true; }

    var addBusy = false;
    function addToBag(product, slot) {
      hideAddError();
      slot = slot || 'primary';
      /* In-flight lock (Codex Sol HIGH, 2026-08-24): without it a
         double-click fires two concurrent /cart/add.js requests and the
         buyer lands on /cart with quantity 2. */
      if (addBusy) return;
      addBusy = true;
      if (!product.variant_id) {
        window.location.href = product.url || '/collections/all';
        return;
      }
      var body = new FormData();
      body.append('id', product.variant_id);
      body.append('quantity', 1);
      /* ONE gift note (founder, 2026-09-09): the card is cart.note + the "To" attribute, shared with
         the drawer and the gift-set builder. The per-product gift_note_default is never stamped on a
         line item in ladder mode — it read as text the buyer had written. */
      if (config.prefill_gift_note && config.scoring_engine !== 'ladder' && product.quiz && product.quiz.gift_note_default) {
        body.append('properties[Gift Note]', product.quiz.gift_note_default);
      }
      /* order-side attribution: underscore props are hidden at checkout */
      body.append('properties[_gf_quiz]', config.quiz_id || 'gift_quiz');
      body.append('properties[_gf_session]', state.sessionId);
      body.append('properties[_gf_slot]', slot);
      body.append('properties[_gf_surface]', surface);
      syncRecipientAttribute().then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          body: body,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
      })
        .then(function (res) {
          /* Check res.ok — /cart/add.js returns 422 for sold-out /
             unavailable variants. The 422 body would otherwise resolve
             the success path and falsely "add" the item. */
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error((data && data.description) || 'Could not add to bag');
            });
          }
          return res.json();
        })
        .then(function () {
          noteAdded(product);
          track('gift_quiz_add_to_bag', {
            quiz_id: config.quiz_id,
            matched_product_handle: product.handle,
            price: product.price,
            slot: slot
          });
          if (slot === 'strip') track('gift_quiz_strip_add', { matched_product_handle: product.handle });
          sendTelemetry({ event: 'add_to_bag', added_handle: product.handle, slot: slot });
          if (stripEl) stripEl.hidden = true;
          /* Native cart drawer (2026-08-24): open it in place so the
             browse-and-add loop survives (founder ruling — a /cart
             redirect kills AOV). Falls back to /cart when absent. */
          if (document.querySelector('[data-section-type="cart-drawer"]')) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            addBusy = false;
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          addBusy = false;
          /* In place, stay in place (2026-09-08): the band promised no bouncing, so a
             failed add shows an inline line with a link to the product instead of
             leaving the collection. The full page keeps the legacy PDP fallback. */
          if (isBand) { showAddError(product, err); return; }
          window.location.href = product.url || '/collections/all';
        });
    }

    /* ——— "Goes with it" pairings (redesigned 2026-08-24) ———
       At most two quiet per-item pairings beside the match. Sources, in
       order: curated quiz.bundle_partners metafield → Shopify complementary
       recommendations → related recommendations. The section stays hidden
       unless at least one card exists (no ritual-total shell, no add-all). */
    function renderPairs(primary) {
      if (!bundleEl || !bundleGrid) return;
      clearEl(bundleGrid);
      bundleEl.hidden = true;

      var exclude = {};
      exclude[primary.handle] = true;
      (state.lastAlternates || []).forEach(function (h) { exclude[h] = true; });

      /* Curated partners are resolved THROUGH the pool (Codex Sol HIGH,
         2026-08-24): the pool excludes sold-out products at serialization,
         so a curated-but-unavailable partner can never paint an active
         "+ Add". Merchant order is kept; only exclusions apply. */
      var curated = (Array.isArray(primary.bundle_partners) ? primary.bundle_partners : [])
        .map(function (bp) {
          if (!bp || !bp.handle || exclude[bp.handle]) return null;
          return products.find(function (p2) { return p2 && p2.handle === bp.handle; }) || null;
        })
        .filter(function (p2) { return p2 && p2.variant_id; });
      if (curated.length) { paintPairs(curated.slice(0, 2)); return; }
      if (!config.bundle_fallback_enabled) return;

      /* Deterministic in-pool complements (2026-08-24): Shopify's
         complementary intent returns 0 until Search & Discovery pairs are
         configured, and `related` returns SUBSTITUTES — two more gift sets
         under "Goes with it" read as competition, not completion. Instead:
         a different product type, at most 80% of the match's price (adds to
         the gift, never rivals it), most-reviewed first. The pool already
         excludes sold-out products at serialization. */
      var complements = products
        .filter(function (p2) {
          return p2 && p2.variant_id && p2.handle !== primary.handle && !exclude[p2.handle] &&
            (p2.type || '') !== (primary.type || '') &&
            p2.type !== 'Mandala Tapestry' &&
            typeof p2.price === 'number' && typeof primary.price === 'number' &&
            p2.price <= primary.price * 0.8;
        })
        .sort(function (a, b) { return (b.review_count || 0) - (a.review_count || 0); })
        .slice(0, 2);
      if (complements.length) paintPairs(complements);
    }

    function paintPairs(partners) {
      clearEl(bundleGrid);
      partners.forEach(function (bp) {
        if (!bp) return;
        var row = document.createElement('div');
        row.className = 'gift-quiz__pair';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'gift-quiz__pair-img';
        if (bp.image) {
          var img = document.createElement('img');
          img.src = bp.image;
          img.alt = bp.image_alt || bp.title || '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }
        row.appendChild(imgWrap);

        var body = document.createElement('div');
        body.className = 'gift-quiz__pair-body';

        var title = document.createElement('p');
        title.className = 'gift-quiz__pair-title';
        if (bp.url) {
          var link = document.createElement('a');
          link.href = bp.url;
          link.textContent = bp.title || '';
          title.appendChild(link);
        } else {
          title.textContent = bp.title || '';
        }
        body.appendChild(title);

        var price = document.createElement('p');
        price.className = 'gift-quiz__pair-price';
        price.textContent = bp.price_formatted || '';
        body.appendChild(price);
        row.appendChild(body);

        var quickAdd = document.createElement('button');
        quickAdd.type = 'button';
        quickAdd.className = 'gift-quiz__pair-add';
        quickAdd.textContent = '+ Add';
        quickAdd.setAttribute('aria-label', 'Add ' + (bp.title || 'item') + ' to bag');
        quickAdd.addEventListener('click', function (e) {
          e.preventDefault();
          addToBag(bp, 'pair');
        });
        row.appendChild(quickAdd);

        bundleGrid.appendChild(row);
      });
      bundleEl.hidden = partners.length === 0;
    }

    /* ——— Edit-answers panel (Function-of-Beauty pattern, plan §8) ——— */
    function renderEditAnswers() {
      if (!answersEl || !answersList || !config.show_edit_answers) return;
      clearEl(answersList);

      var rendered = 0;
      state.answers.forEach(function (a, qIndex) {
        if (!a) return;
        var q = questions[qIndex];
        if (!q) return;

        var option = (q.options || []).find(function (o) { return o.tag === a.tag; });
        var optionLabel = (option && option.label) || a.tag;

        if (config.scoring_engine === 'ladder') {
          /* one line: the values, each a quiet link back to its question (2026-09-09 refinement) */
          var item = document.createElement('li');
          item.className = 'gift-quiz__answer gift-quiz__answer--inline';
          var link = document.createElement('button');
          link.type = 'button';
          link.className = 'gift-quiz__answer-change gift-quiz__answer-change--inline';
          link.textContent = optionLabel;
          link.setAttribute('aria-label', 'Change: ' + (q.text || q.key) + ' — ' + optionLabel);
          link.addEventListener('click', function () {
            resultEl.hidden = true;
            if (bundleEl) bundleEl.hidden = true;
            if (a.locked) { a.locked = false; }
            goToQuestion(qIndex);
            track('gift_quiz_answer_edit_opened', { quiz_id: config.quiz_id, question_index: qIndex });
          });
          item.appendChild(link);
          answersList.appendChild(item);
          rendered += 1;
          return;
        }
        var li = document.createElement('li');
        li.className = 'gift-quiz__answer';

        var qText = document.createElement('span');
        qText.className = 'gift-quiz__answer-q';
        var SHORT = { buyer_type: 'For', occasion: 'Occasion', concern: 'Needs', ritual: 'Ritual', scent: 'Scent', price: 'Budget' };
        qText.textContent = (config.scoring_engine === 'ladder' && SHORT[q.key]) ? SHORT[q.key] : (q.text || q.key || ('Q' + (qIndex + 1)));
        li.appendChild(qText);

        var aText = document.createElement('span');
        aText.className = 'gift-quiz__answer-a';
        aText.textContent = optionLabel;
        li.appendChild(aText);

        var changeBtn = document.createElement('button');
        changeBtn.type = 'button';
        changeBtn.className = 'gift-quiz__answer-change';
        changeBtn.textContent = config.edit_answer_label || 'change';
        changeBtn.addEventListener('click', function () {
          resultEl.hidden = true;
          if (bundleEl) bundleEl.hidden = true;
          if (a.locked) { a.locked = false; }
          goToQuestion(qIndex);
          track('gift_quiz_answer_edit_opened', { quiz_id: config.quiz_id, question_index: qIndex });
        });
        li.appendChild(changeBtn);

        answersList.appendChild(li);
        rendered += 1;
      });

      answersEl.hidden = rendered === 0;
    }

    /* formatMoney body is wrapped in a Liquid raw block below because
       Shopify money_format tokens look like Liquid variable syntax. */
    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var fmt = (document.body && document.body.dataset && document.body.dataset.moneyFormat)
                || (window.Shopify && window.Shopify.money_format)
                || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      var whole = String(Math.round(cents / 100));
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole);
    }

    function trackKlaviyo(eventName, payload) {
      /* Klaviyo onsite JS loads asynchronously. _learnq queues events until SDK is ready. */
      try {
        if (!eventName) return;
        window._learnq = window._learnq || [];
        window._learnq.push(['track', eventName, payload || {}]);
        if (payload && payload.matched_handle) {
          var identify = {};
          ['scent_pref','price_pref','persona_pref','peace_pref','recipient_pref','last_match_handle','last_quiz_id','last_quiz_at','occasion_fit'].forEach(function (k) {
            if (payload[k] !== undefined && payload[k] !== null) identify[k] = payload[k];
          });
          if (Object.keys(identify).length) window._learnq.push(['identify', identify]);
        }
      } catch (_) { /* Klaviyo is best-effort */ }
    }

    function wireEmailForm(product) {
      var input = emailForm.querySelector('[data-quiz-email-input]');
      var status = emailForm.querySelector('[data-quiz-email-status]');
      var consent = emailForm.querySelector('[data-quiz-email-consent]');
      /* asked once: a buyer who already left an email is not asked again */
      try { if (localStorage.getItem('gift-quiz-email-saved')) { emailForm.hidden = true; return; } } catch (_) {}
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = input.value.trim();
        if (!email || email.indexOf('@') === -1) {
          status.hidden = false; status.textContent = 'That email doesn\u2019t look right \u2014 one more try?';
          return;
        }
        if (consent && !consent.checked) {
          status.hidden = false; status.textContent = 'Tick the box so we\u2019re allowed to write to you.';
          return;
        }

        track('gift_quiz_email_captured', {
          quiz_id: config.quiz_id,
          list_id: config.email_list_id || null,
          matched_product_handle: product.handle,
          email_hash: hashEmail(email)
        });

        /* Real consented subscribe when the rig is configured (2026-08-24) —
           the old identify-only path created an unmailable profile and promised
           an email nothing sent. */
        try {
          var kPayload = buildProfilePayload(product, Date.now() - state.startedAt);
          kPayload.$email = email;
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', { $email: email }]);
          window._learnq.push(['track', 'Captured ' + (config.quiz_name || 'Gift Quiz') + ' Email', kPayload]);
        } catch (_) { /* best-effort */ }
        if (config.klaviyo_public_key && config.email_list_id) {
          state.pendingResult = { primary: { product: product } };
          subscribeProfile(email, function () { /* status already shown */ });
        }

        status.hidden = false;
        status.textContent = 'Saved \u2014 a welcome note is on its way.';
        input.disabled = true;
        try { localStorage.setItem('gift-quiz-email-saved', '1'); } catch (_) {}
      });
    }

    function showResultFromSavedWired(saved, matchedProduct) {
      showResultFromSaved(saved, matchedProduct);
      if (emailForm && !state.emailFormWired) { state.emailFormWired = true; wireEmailForm(matchedProduct); }
    }

    function showResultFromSaved(saved, product) {
      if (introEl) introEl.setAttribute('hidden', '');
      welcomeEl.hidden = true;

      /* Hydrate state.answers so renderEditAnswers can show the saved selections. */
      if (saved && Array.isArray(saved.answers)) {
        state.answers = saved.answers.slice();
      }

      renderPrimary(product, false);
      renderAlternates([]);
      renderMeta(0, products.length);
      renderEditAnswers();
      state.lastAlternates = [];
      if (config.scoring_engine === 'ladder') {
        var comp2 = composeLadder(scoreCandidates(products, state.answers));
        renderStepUp(comp2.stepUp && comp2.stepUp.handle !== product.handle ? comp2.stepUp : null, product);
        renderAddOn(comp2.addOn && comp2.addOn.handle !== product.handle ? comp2.addOn : null, product);
      } else if (bundleEl) renderPairs(product);

      hideAllQuestions();
      resultEl.hidden = false;
      state.lastResult = { primaryId: product.id, altIds: [] };
      markGrid();
      observeGrid();
      armStrip(product);
      if (recipientWrap) recipientWrap.hidden = !(config.recipient && config.recipient.enabled && isGiftBuyer());
      if (recipientInput && state.recipient) recipientInput.value = state.recipient;
      updateNamedEyebrow();
      hydrateGiftNoteFromCart();
      resultEl.scrollIntoView({ behavior: (prefersReducedMotion() ? 'auto' : 'smooth'), block: 'start' });
    }

    /* ——— "Your match" marks on the collection grid below (2026-09-08) ———
       Cards carry only the class product-{id}; the match is stamped as a chip
       inside .product-wrap. Idempotent, re-applied after load-more / filter
       re-renders by one rAF-debounced MutationObserver. Never reorders. */
    var markObserver = null;
    function markGrid() {
      if (!config.mark_grid || !state.lastResult) return;
      var r = state.lastResult;
      var slots = {};
      (r.altIds || []).forEach(function (id) { if (id !== r.primaryId) slots[id] = 'alternate'; });
      slots[r.primaryId] = 'primary';
      /* a chip from an earlier (saved) match on a card outside the current result set is stale */
      var stale = document.querySelectorAll('[data-gq-marked][data-gq-owner="' + sectionId + '"]');
      for (var s = 0; s < stale.length; s++) {
        var idm = /(?:^|\s)product-(\d+)(?:\s|$)/.exec(stale[s].className || '');
        if (idm && slots[idm[1]] === stale[s].getAttribute('data-gq-marked')) continue;
        var oldChip = stale[s].querySelector('.gq-mark');
        if (oldChip) oldChip.parentNode.removeChild(oldChip);
        stale[s].removeAttribute('data-gq-marked');
      }
      Object.keys(slots).forEach(function (id) {
        var nodes = document.querySelectorAll('.thumbnail > .product-' + id);
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (root.contains(n) || (n.getAttribute('data-gq-marked') === slots[id] && n.getAttribute('data-gq-owner') === sectionId)) continue;
          var wrap = n.querySelector('.product-wrap') || n;
          var old = wrap.querySelector('.gq-mark');
          if (old) old.parentNode.removeChild(old);
          var chip = document.createElement('span');
          chip.className = 'gq-mark gq-mark--' + slots[id];
          chip.setAttribute('data-gq-mark', slots[id]);
          chip.setAttribute('data-gq-owner', sectionId);
          n.setAttribute('data-gq-owner', sectionId);
          chip.textContent = slots[id] === 'primary' ? (config.mark_label_primary || 'Your match') : (config.mark_label_alternate || 'Second opinion');
          wrap.insertBefore(chip, wrap.firstChild);
          n.setAttribute('data-gq-marked', slots[id]);
        }
      });
    }
    function clearMarks() {
      var chips = document.querySelectorAll('.gq-mark[data-gq-owner="' + sectionId + '"]');
      for (var i = 0; i < chips.length; i++) {
        var host = chips[i].closest('[data-gq-marked]');
        if (host) host.removeAttribute('data-gq-marked');
        chips[i].parentNode.removeChild(chips[i]);
      }
    }
    function observeGrid() {
      if (markObserver || !config.mark_grid || typeof MutationObserver !== 'function') return;
      var raf = null;
      markObserver = new MutationObserver(function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; markGrid(); });
      });
      /* scope: the main content region (quickFilter replaces the grid NODE itself,
         so its parent must be watched); body only as a last resort */
      var scope = document.querySelector('#MainContent, main') || document.body;
      watch(markObserver).observe(scope, { childList: true, subtree: true });
      /* one delegated listener for the page; it reads the CURRENT instance's tracker
         from the registry so a reloaded section never reports through a dead closure */
      window.__gqMarkClick = window.__gqMarkClick || {};
      window.__gqMarkClick[sectionId] = track;
      if (!window.__gqMarkClickWired) {
        window.__gqMarkClickWired = true;
        document.addEventListener('click', function (e) {
          var host = e.target && e.target.closest ? e.target.closest('[data-gq-marked]') : null;
          if (!host) return;
          var fn = window.__gqMarkClick && window.__gqMarkClick[host.getAttribute('data-gq-owner')];
          if (typeof fn === 'function') fn('gift_quiz_mark_click', { slot: host.getAttribute('data-gq-marked') });
        });
      }
    }

    /* ——— Mobile "your match" strip (2026-09-08) ——— */
    function armStrip(product) {
      if (!stripEl || !config.strip_enabled || !product) return;
      var img = stripEl.querySelector('[data-quiz-strip-img]');
      var title = stripEl.querySelector('[data-quiz-strip-title]');
      var add = stripEl.querySelector('[data-quiz-strip-add]');
      var dismiss = stripEl.querySelector('[data-quiz-strip-dismiss]');
      if (img) { if (product.image) { img.src = product.image; img.alt = ''; img.hidden = false; } else { img.hidden = true; } }
      if (title) title.textContent = product.title || '';
      if (add) add.onclick = function () { addToBag(product, 'strip'); };
      if (dismiss) dismiss.onclick = function () { state.stripDismissed = true; stripEl.hidden = true; };
      state.stripArmed = true;
      if (!state.stripWired) {
        state.stripWired = true;
        var pending = null;
        var onScroll = function () { if (pending) return; pending = requestAnimationFrame(function () { pending = null; updateStrip(); }); };
        on(window, 'scroll', onScroll, { passive: true });
        on(window, 'resize', onScroll);
        on(document, 'cart:open', function () { stripEl.hidden = true; });
        if (typeof IntersectionObserver === 'function') {
          var io = watch(new IntersectionObserver(function (entries) { entries.forEach(function (en) { state.resultInView = en.isIntersecting; }); updateStrip(); }, { threshold: [0] }));
          io.observe(resultEl);
        }
      }
      updateStrip();
    }
    function updateStrip() {
      if (!stripEl || !state.stripArmed) return;
      var footer = document.querySelector('footer');
      var footerNear = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var resultAbove = resultEl.getBoundingClientRect().bottom < 0;
      var show = window.innerWidth < 768 && !state.stripDismissed && !state.resultInView && resultAbove && !footerNear
        && !document.querySelector('[data-cdw].is-open') && !document.querySelector('.msa:not([hidden])');
      if (show === !stripEl.hidden) return;
      stripEl.hidden = !show;
      if (show && !state.stripShownTracked) { state.stripShownTracked = true; track('gift_quiz_strip_shown', {}); }
    }

    /* the one reset (2026-09-09): Start over AND the strip's Retake run this */
    function resetQuiz() {
        clearSaved();
        var syncedBefore = state.recipientSynced || '';
        state = {
          answers: new Array(questions.length).fill(null),
          currentIndex: 0,
          startedAt: Date.now(),
          perQuestionAt: [Date.now()],
          sessionId: 'gfq-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10),
          recipient: '',
          recipientSynced: syncedBefore,
          lastResult: null
        };
        clearRecipient();
        state.gatePassed = false;
        state.pendingResult = null;
        state.lastResult = null;
        state.stripArmed = false;
        if (stripEl) stripEl.hidden = true;
        if (recipientWrap) recipientWrap.hidden = true;
        if (resultEyebrowEl) resultEyebrowEl.textContent = resultEyebrowDefault;
        clearMarks();
        gateRevealed = false;   /* a second run must be able to pass the gate again */
        hasStartedEvent = false; /* run 2 gets its own gift_quiz_started */
        resultEl.hidden = true;
        if (gateEl) gateEl.hidden = true;
        if (bundleEl) bundleEl.hidden = true;
        if (answersEl) answersEl.hidden = true;
        questionNodes.forEach(function (n, i) {
          n.hidden = i !== 0;
          n.classList.toggle('is-active', i === 0);
          n.querySelectorAll('[data-quiz-option]').forEach(function (opt) { opt.classList.remove('is-selected'); });
          n.querySelectorAll('[data-quiz-option-input]').forEach(function (inp) { inp.checked = false; });
          /* the "Something else" field and its text are state too */
          n.querySelectorAll('[data-quiz-other-wrap]').forEach(function (w) { w.hidden = true; });
          n.querySelectorAll('[data-quiz-other-input]').forEach(function (inp) { inp.value = ''; });
          var nextBtn = n.querySelector('[data-quiz-next]');
          if (nextBtn) nextBtn.disabled = true;
        });
        /* a restart is a fresh first paint: branch-hidden segments come back
           to their first-paint state (visible unless the block has show_if) */
        var branchSeen = false;
        progressNodes.forEach(function (n, i) {
          var q = questions[i];
          var hide = false;
          if (q && q.show_if) { hide = branchSeen; branchSeen = true; }
          n.style.display = hide ? 'none' : '';
          n.classList.toggle('is-active', i === 0);
          n.classList.remove('is-complete');
          n.setAttribute('aria-current', i === 0 ? 'step' : 'false');
        });
        if (introEl) introEl.removeAttribute('hidden');
        /* context locks survive a restart; start at the first question the buyer actually sees */
        applyContextLocks();
        var firstAfterRestart = firstVisibleIndex();
        if (firstAfterRestart !== 0) goToQuestion(firstAfterRestart, { noFocus: true });
    }
    if (restartBtn) {
      restartBtn.addEventListener('click', function () { resetQuiz(); track('gift_quiz_restarted', { quiz_id: config.quiz_id }); });
    }

    /* first paint: lock context answers and stand on the first visible question */
    applyContextLocks();
    var firstVisible = firstVisibleIndex();
    if (firstVisible !== 0) goToQuestion(firstVisible, { noFocus: true });

    // —— Helpers ——

    function savePersistence(obj) {
      try {
        obj.ttl_days = config.ttl_days || 14;
        localStorage.setItem(config.storage_key || 'monsuri_gift_quiz_result', JSON.stringify(obj));
      } catch (_) { /* no-op */ }
    }
    function loadSaved() {
      try {
        var raw = localStorage.getItem(config.storage_key || 'monsuri_gift_quiz_result');
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        var ttl = (parsed.ttl_days || 14) * 24 * 60 * 60 * 1000;
        if (Date.now() - parsed.ts > ttl) { clearSaved(); return null; }
        /* a result saved by another engine's option set is not re-read (Opus review H2) */
        if ((parsed.engine || 'tags') !== (config.scoring_engine || 'tags')) { clearSaved(); return null; }
        return parsed;
      } catch (_) { return null; }
    }
    function clearSaved() {
      try { localStorage.removeItem(config.storage_key || 'monsuri_gift_quiz_result'); } catch (_) {}
    }

    function safeJson(node) {
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (_) { return null; }
    }

    /* Analytics (2026-09-08): GTM is dead on this theme — only a direct gtag
       call with send_to reaches GA4 (the drawer's pattern). Every event carries
       the surface + collection so the collection band can be read apart from
       the page. dataLayer is the fallback when gtag is absent. */
    var GA4_ID = 'G-04VG181C0C';
    function track(event, payload) {
      try {
        var p = {
          quiz_id: config.quiz_id,
          surface: surface,
          collection_handle: config.collection_handle || null,
          presentation: config.presentation || 'full',
          context_locked: root.dataset.quizContextLocked || ''
        };
        var src = payload || {};
        Object.keys(src).forEach(function (k) { p[k] = Array.isArray(src[k]) ? src[k].join(',') : src[k]; });
        if (typeof window.gtag === 'function') {
          p.send_to = GA4_ID;
          window.gtag('event', event, p);
          return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: event, section_id: sectionId }, p));
      } catch (_) {}
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function hashEmail(e) {
      var h = 0, i, chr;
      if (e.length === 0) return '0';
      for (i = 0; i < e.length; i++) {
        chr = e.charCodeAt(i);
        h = ((h << 5) - h) + chr;
        h |= 0;
      }
      return String(h);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-section-type="gift-quiz"]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var host = e && e.target && e.target.querySelector ? e.target : document;
    var root = host.querySelector('[data-section-type="gift-quiz"]');
    if (root) { root.dataset.quizInit = ''; initRoot(root); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e && e.detail && e.detail.sectionId;
    if (id && window.__gq && window.__gq[id] && typeof window.__gq[id].teardown === 'function') window.__gq[id].teardown();
  });
})();
